// ======== COMPLETE GEURKALENDER.JS v19 - ALLE FIXES ========
// 🔥 FIXED: Cache invalidation + Server labels voor subscribers + UTC lock cutoffs

// =========================================================
// 🖼️ GEDEELDE FOTO-HERSTELLER (window.smRefreshProductImg)
// Opgeslagen image-URL's verouderen zodra je een productfoto in Shopify
// vervangt/verwijdert (oude CDN-URL → 404). Deze helper haalt de HUIDIGE
// foto live op via /products/<handle>.js → featured_image en wisselt 'm om.
// Wordt alleen aangeroepen als een <img> faalt (onerror), dus geen extra
// laadkost bij normale weergave. Guarded → veilig om in meerdere bestanden
// te definiëren; de eerste die laadt wint, de definities zijn identiek.
// =========================================================
(function(){
  if (window.smRefreshProductImg) return;
  var cache = {};
  var PLACEHOLDER = 'https://cdn.shopify.com/s/files/1/0936/1263/8543/files/atomizer-112.webp?v=1757683968';
  function handleFrom(u){
    if (!u || u === '#') return '';
    try {
      var path = u.indexOf('http') === 0 ? new URL(u).pathname : u;
      var m = path.match(/\/products\/([^\/?#]+)/);
      return m ? decodeURIComponent(m[1]) : '';
    } catch(e){ return ''; }
  }
  // imgEl: het <img> element; productUrl: opgeslagen product-URL/handle.
  // opts.proactive=true → haal ALTIJD de huidige foto op (niet wachten op een 404);
  //   mislukt de fetch, dan blijft de huidige foto staan (geen placeholder).
  // standaard (onerror-context) → foto is kapot: vervang door live foto, anders placeholder.
  window.smRefreshProductImg = function(imgEl, productUrl, opts){
    if (!imgEl) return;
    opts = opts || {};
    var proactive = opts.proactive === true;
    var usePlaceholder = opts.placeholder !== false;
    var handle = handleFrom(productUrl || imgEl.dataset.purl);
    var placeholder = function(){
      imgEl.onerror = null;
      if (usePlaceholder && imgEl.src !== PLACEHOLDER) imgEl.src = PLACEHOLDER;
    };
    if (proactive) {
      if (imgEl.dataset.smChecked === '1') return;   // hooguit één keer per element
      imgEl.dataset.smChecked = '1';
      if (!handle) return;                            // niets te doen → huidige foto laten staan
    } else {
      if (imgEl.dataset.smHealed === '1') { placeholder(); return; }  // loop-bescherming
      imgEl.dataset.smHealed = '1';
      if (!handle) { placeholder(); return; }
    }
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function(r){ return r.ok ? r.json() : null; })
        .catch(function(){ return null; });
    }
    cache[handle].then(function(p){
      if (p && p.featured_image) {
        if (imgEl.getAttribute('src') !== p.featured_image) imgEl.src = p.featured_image;
        imgEl.dataset.smHealed = '1';                 // goede live bron; faalt die ooit → placeholder
      } else if (!proactive) {
        placeholder();
      }
    });
  };
})();

// =========================================================
// 🚨 SAFARI BFCACHE FIX
// Zorgt dat Safari de pagina hard ververst als hij uit de cache komt.
// =========================================================
window.addEventListener('pageshow', function(event) {
  if (event.persisted) {
    console.warn('[Geurkalender] Safari bfcache restore detected → forcing reload');
    window.location.reload();
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('geurkalender-modal');
  const closeBtn = document.getElementById('close-geurkalender');
  if (!modal) return;

  // Lock/freeze tijden — moet matchen met backend kalender/timing_config.py
  const FREEZE_HOUR_UTC = 13;
  const SIGNUP_CUTOFF_HOUR_UTC = 12;
  // Lock- en verzenddagen per cyclus. Kopie van kalender/timing_config.py in de
  // backend; handmatig gelijk houden. Cyclus-IDs '15' en '1' blijven, alleen de
  // dagen veranderden (migratie sep 2026: was 6/22 en 15/1).
  const LOCK_DAY_C15 = 10, LOCK_DAY_C1 = 24, SHIP_DAY_C15 = 25, SHIP_DAY_C1 = 9;
  // Eerste dozen van nieuwe klanten gaan vanaf lock + dit aantal dagen de deur uit (afspraak sep 2026).
  const FIRST_SHIP_EARLIEST_DAYS_AFTER_LOCK = 8;

  const API_BASE = (function() {
    const fallback = 'https://smellish-auth.onrender.com';
    try {
      if (typeof window.smellishGetApiBase === 'function') {
        return window.smellishGetApiBase();
      }
      const fromWindow = (window.SMELLISH_API_BASE || '').trim().replace(/\/$/, '');
      if (fromWindow) return fromWindow;
      const meta = document.querySelector('meta[name="smellish-api-base"]');
      if (meta && meta.content) return meta.content.trim().replace(/\/$/, '');
    } catch (_) {}
    return fallback;
  })();
  const monthNames = ["jan","feb","mrt","apr","mei","jun","jul","aug","sep","okt","nov","dec"];
  const HINT_KEY = 'gk_drag_hint_shown';
  const CAL_DEBUG = Boolean(window.SMELLISH_DEBUG_LOGS);
  const calLog = (...args) => { if (CAL_DEBUG) console.log(...args); };
  const calWarn = (...args) => { if (CAL_DEBUG) console.warn(...args); };
  const calError = (...args) => { if (CAL_DEBUG) console.error(...args); };

  window.smDebugShowDay = !!window.smDebugShowDay;

  let cachedVersion = null;
  let lastVersionCheck = 0;
  const VERSION_CACHE_TTL = 60000; // 1 minute cache

  // Login context
  const LOGGED_IN = !!window.smCustomerLoggedIn;
  const CUSTOMER_ID = window.smCustomerId || null;
  const SERVER_OK = LOGGED_IN && !!CUSTOMER_ID;
  const IS_SUBSCRIBER = SERVER_OK && (window.smCustomerCycle === '1' || window.smCustomerCycle === '15');

  // 🎁 Gift subscription blokkade (met localStorage cache voor instant load)
  const GIFT_CACHE_KEY = CUSTOMER_ID ? `gk_gift_status_${CUSTOMER_ID}` : null;
  const BLOCKED_CACHE_KEY = CUSTOMER_ID ? `gk_blocked_variants_${CUSTOMER_ID}` : null;

  // Load from cache first (instant!)
  let isGiftSubscription = false;
  let blockedVariantIds = new Set();

  // 🔥 Instant load from cache
  (function loadGiftCacheInstant() {
    if (!GIFT_CACHE_KEY) return;
    try {
      const cachedGift = localStorage.getItem(GIFT_CACHE_KEY);
      const cachedBlocked = localStorage.getItem(BLOCKED_CACHE_KEY);

      if (cachedGift === 'true') {
        isGiftSubscription = true;
        if (cachedBlocked) {
          blockedVariantIds = new Set(JSON.parse(cachedBlocked));
          calLog('[GIFT] Loaded from cache:', blockedVariantIds.size, 'blocked variants');
        }
      }
    } catch(_) {}
  })();

  // 🔥 JWT RAM-cache voor snellere API calls
  let _jwtTokenCache = null;

  function clearJwtCache() {
    _jwtTokenCache = null;
    calLog('[AUTH] JWT cache cleared');
  }

  // Uitloggen gebeurt in theme.liquid en kon hier niet bij: die wiste alleen de
  // cache van account-dashboard.js. Daardoor bleef de kalender na het uitloggen
  // met zijn oude token doorwerken.
  //
  // Let op de volgorde. De beforeunload-opslag verderop schrijft een nog niet
  // opgeslagen wijziging alsnog weg, maar die draait NA deze functie. Zouden we
  // hier meteen het token weggooien, dan mislukt die laatste opslag en ben je
  // de geur kwijt die je net had versleept. Dus eerst wegschrijven met het
  // token dat we nu nog hebben, daarna pas opruimen.
  window.resetKalenderJwtCache = function () {
    try {
      if (dirty && SERVER_OK && !inflight && _jwtTokenCache) {
        const snapshot = (geurkalender || []).slice(0, 12).map(sanitizeItem);
        const currentVersion = parseInt(localStorage.getItem(`gk_version_${CUSTOMER_ID}`) || '0');
        // Headers hier direct opbouwen en niet via getAuthHeaders(): die is
        // async, en tegen de tijd dat hij klaar is hebben we het token al weg.
        fetch(API_BASE + '/calendar/save', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Customer-Token': _jwtTokenCache
          },
          body: JSON.stringify({
            customer_id: CUSTOMER_ID,
            months: snapshot,
            clientUpdatedAt: lastServerUpdatedAtISO || null,
            version: currentVersion
          }),
          keepalive: true
        }).catch(function () {});
        dirty = false;   // voorkomt dat beforeunload het nog eens probeert
        calLog('[AUTH] Laatste wijziging weggeschreven voor het uitloggen');
      }
    } catch (_) {}

    clearJwtCache();
  };

  // Hoe lang we maximaal wachten tot het echte token beschikbaar is. Dat token
  // komt uit token-inline.js en is er soms net nog niet als de klant meteen een
  // geur aanklikt.
  const JWT_WACHT_MS = 4000;

  // window.getCustomerJWTToken() en theme.liquid geven bij een mislukking het
  // OUDE token `customer_<id>` terug. Dat wordt sinds ALLOW_LEGACY_CUSTOMER_TOKENS
  // =false altijd geweigerd, dus dat is geen geldig token maar een verkapte fout.
  const isEchtToken = (t) => !!t && !String(t).startsWith('customer_');

  async function getJwtToken() {
    // Return cached token if available
    if (_jwtTokenCache) {
      return _jwtTokenCache;
    }

    // 🔐 Priority 1: Use pre-fetched token from theme.liquid (fastest path)
    if (isEchtToken(window.smellishAuthToken)) {
      _jwtTokenCache = window.smellishAuthToken;
      return _jwtTokenCache;
    }

    // 🔐 Priority 2: Wait for pre-fetch promise if available
    if (window.smellishAuthTokenPromise) {
      try {
        const token = await window.smellishAuthTokenPromise;
        if (isEchtToken(token)) {
          _jwtTokenCache = token;
          return _jwtTokenCache;
        }
      } catch (e) {
        calLog('[AUTH] Token promise failed, falling back:', e);
      }
    }

    // 🔐 Priority 3: zelf ophalen zodra de tokenfunctie geladen is.
    // Kort blijven proberen in plaats van meteen opgeven: token-inline.js is
    // vaak binnen een fractie van een seconde alsnog binnen.
    const deadline = Date.now() + JWT_WACHT_MS;
    while (Date.now() < deadline) {
      if (isEchtToken(window.smellishAuthToken)) {
        _jwtTokenCache = window.smellishAuthToken;
        return _jwtTokenCache;
      }
      if (CUSTOMER_ID && typeof window.getCustomerJWTToken === 'function') {
        try {
          const token = await window.getCustomerJWTToken(CUSTOMER_ID);
          if (isEchtToken(token)) {
            _jwtTokenCache = token;
            return _jwtTokenCache;
          }
        } catch (e) {
          calLog('[AUTH] Ophalen token mislukt:', e);
        }
      }
      await new Promise((r) => setTimeout(r, 150));
    }

    // Geen geldig token. Hier stond vroeger `customer_<id>`, maar dat oude
    // formaat wordt sinds ALLOW_LEGACY_CUSTOMER_TOKENS=false altijd geweigerd.
    // Dat leverde een gegarandeerde 401 op en de klant raakte zijn keuze kwijt
    // zonder dat hij iets zag. Liever niets sturen: de aanroeper stelt de save
    // dan uit tot het token er wel is.
    calError('[AUTH] Geen geldig token beschikbaar');
    return null;
  }

  async function getAuthHeaders() {
    const headers = { 'Content-Type': 'application/json' };
    if (CUSTOMER_ID) {
      const token = await getJwtToken();
      // Zonder geldig token de header weglaten. Een lege of onjuiste waarde
      // meesturen levert alleen een 401 op.
      if (token) headers['X-Shopify-Customer-Token'] = token;
    }
    return headers;
  }

  async function getCacheHeaders() {
    const headers = {
      'Cache-Control': 'no-cache',
      'Content-Type': 'application/json'
    };
    if (CUSTOMER_ID) {
      const token = await getJwtToken();
      // Zonder geldig token de header weglaten. Een lege of onjuiste waarde
      // meesturen levert alleen een 401 op.
      if (token) headers['X-Shopify-Customer-Token'] = token;
    }
    return headers;
  }

  // localStorage keys
  const GUEST_KEY = 'geurkalender_guest';
  const USER_KEY = CUSTOMER_ID ? ('geurkalender__' + CUSTOMER_ID) : null;
  const ACTIVE_KEY = USER_KEY || GUEST_KEY;
  const LAST_UID_KEY = 'gk_last_uid';
  const LABELS_CACHE_KEY = CUSTOMER_ID ? ('gk_labels_' + CUSTOMER_ID) : null;
  const LAST_REFRESH_KEY = CUSTOMER_ID ? ('gk_last_refresh_' + CUSTOMER_ID) : null;

  // updatedAt tracking
  const UPDATED_KEY = CUSTOMER_ID ? ('geurkalender_updated__' + CUSTOMER_ID) : 'geurkalender_guest_updated';
  const UPDATED_MS_KEY = UPDATED_KEY + '__ms';
  const readUpdatedISO = () => { try { return localStorage.getItem(UPDATED_KEY) || null; } catch(_) { return null; } };
  const readUpdatedMS  = () => { try { return parseInt(localStorage.getItem(UPDATED_MS_KEY)||'0',10) || 0; } catch(_) { return 0; } };
  const writeUpdated   = (iso, ms) => { try { if (iso) localStorage.setItem(UPDATED_KEY, iso); if (ms>0) localStorage.setItem(UPDATED_MS_KEY, String(ms)); } catch(_) {} };
  // FIX (2026-05-15): backend GET /calendar retourneert naive ISO (zonder TZ-marker)
  // terwijl POST /save tz-aware ISO retourneert (met +00:00). Date.parse zonder
  // marker interpreteert als LOCAL time → op NL-systemen 1-2u verschil → de
  // "Local newer than server" branch in refreshFromServer (regel ~936) triggert
  // ten onrechte en pusht de (lege/stale) localStorage state naar de backend,
  // waardoor data van een andere client (zoals headless) gewist wordt.
  // Met deze fix wordt naive ISO consistent als UTC geïnterpreteerd, identiek
  // aan hoe de backend ze opslaat (timestamp without time zone, UTC).
  const tsNum = (ts) => {
    if (!ts || typeof ts !== 'string') return 0;
    const hasTz = /[zZ]$|[+-]\d{2}:?\d{2}$/.test(ts);
    const normalized = hasTz ? ts : ts + 'Z';
    const n = Date.parse(normalized);
    return Number.isFinite(n) ? n : 0;
  };

// 🔥 FIXED: Check of lokale data 'over de datum' is t.o.v. het lock-moment
// Fix: Berekent nu correct het LAATSTE lock moment (ook als dat in vorige maand was)
function isLocalDataExpired() {
  const lastUpdate = readUpdatedMS();
  if (!lastUpdate) return true;

  const now = new Date();
  const cycle = window.smCustomerCycle || '15';
  const lockDay = cycle === '15' ? LOCK_DAY_C15 : LOCK_DAY_C1;

  // Bereken het LAATSTE lock moment dat GEPASSEERD is (UTC = de echte freeze,
  // FREEZE_HOUR_UTC; DST-correct i.t.t. de oude lokale-tijd-heuristiek)
  let lockMoment = new Date(Date.UTC(
    now.getUTCFullYear(), now.getUTCMonth(), lockDay, FREEZE_HOUR_UTC, 0, 0
  ));

  // Als lockMoment in de toekomst ligt, pak vorige maand
  if (lockMoment > now) {
    lockMoment.setUTCMonth(lockMoment.getUTCMonth() - 1);
  }

  // Check of data van vóór de laatste lock is
  if (lastUpdate < lockMoment.getTime()) {
    calLog('[CACHE] Data is van voor de lock (Expired) -> Force Refresh');
    return true;
  }

  // Extra veiligheid: Data ouder dan 20 dagen altijd verversen
  if ((now.getTime() - lastUpdate) > (20 * 24 * 60 * 60 * 1000)) {
      return true;
  }
  return false;
}

  // 🔥 NIEUW: Cache invalidation helpers
  const readCachedLabels = () => { 
    if (!LABELS_CACHE_KEY) return null;
    try { 
      const cached = sessionStorage.getItem(LABELS_CACHE_KEY);
      return cached ? JSON.parse(cached) : null;
    } catch(_) { 
      return null; 
    } 
  };
  
  const writeCachedLabels = (labels) => { 
    if (!LABELS_CACHE_KEY || !labels) return;
    try { 
      sessionStorage.setItem(LABELS_CACHE_KEY, JSON.stringify(labels)); 
    } catch(_) {} 
  };

  const clearCachedLabels = () => {
    if (!LABELS_CACHE_KEY) return;
    try {
      sessionStorage.removeItem(LABELS_CACHE_KEY);
      calLog('[CACHE] Labels cleared');
    } catch(_) {}
  };

  // 🔥 NIEUW: Check of we binnen lock window zitten (2u na lock)
  function checkIfShouldRefreshLabels() {
    if (!IS_SUBSCRIBER) return false;
    
    const now = new Date();
    const utcHour = now.getUTCHours();
    const utcDay = now.getUTCDate();
    const cycle = window.smCustomerCycle || '15';
    
    // Lock momenten (UTC FREEZE_HOUR_UTC):
    // - Cycle 15: LOCK_DAY_C15 (10e) om FREEZE_HOUR_UTC
    // - Cycle 1: LOCK_DAY_C1 (24e) om FREEZE_HOUR_UTC
    const isLockDay = (cycle === '15' && utcDay === LOCK_DAY_C15) || (cycle === '1' && utcDay === LOCK_DAY_C1);

    // Window: FREEZE_HOUR_UTC tot +2 uur (2 uur na lock)
    const isLockWindow = isLockDay && utcHour >= FREEZE_HOUR_UTC && utcHour < FREEZE_HOUR_UTC + 2;
    
    if (isLockWindow) {
      calLog('[CACHE] Lock window detected - will refresh labels');
      return true;
    }
    
    // Check timestamp van laatste refresh
    try {
      const lastRefresh = localStorage.getItem(LAST_REFRESH_KEY);
      if (!lastRefresh) return true;
      
      const lastTime = parseInt(lastRefresh, 10);
      const elapsed = Date.now() - lastTime;
      const ONE_DAY = 24 * 60 * 60 * 1000;
      
      // Refresh als laatste refresh >24u geleden was
      if (elapsed > ONE_DAY) {
        calLog('[CACHE] Last refresh >24h ago - will refresh');
        return true;
      }
    } catch(_) {}
    
    return false;
  }

  let labelsPreloaded = false;
  let isLoadingLabels = false;

  // Legacy migratie
  (function migrateLegacyKey(){
    try {
      const legacy = localStorage.getItem('geurkalender');
      if (legacy) {
        localStorage.setItem('geurkalender_guest', legacy);
        localStorage.removeItem('geurkalender');
      }
    } catch(_) {}
  })();

  // Logout cleanup
  (function handleLogoutCleanup(){
    try {
      const prevUid = localStorage.getItem(LAST_UID_KEY);
      if (SERVER_OK && CUSTOMER_ID) {
        localStorage.setItem(LAST_UID_KEY, String(CUSTOMER_ID));
      } else {
        if (prevUid) {
          localStorage.removeItem(GUEST_KEY);
          localStorage.removeItem('geurkalender_guest_updated');
          localStorage.removeItem('geurkalender_guest_updated__ms');
          localStorage.removeItem(LAST_UID_KEY);
        }
      }
    } catch(_){}
  })();

  const readLocal  = (key) => { try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch(_){ return []; } };
  const writeLocal = (key, months) => { try { localStorage.setItem(key, JSON.stringify(months || [])); } catch(_) {} };

  async function attemptMergeGuestIntoUser(){
    if (!SERVER_OK || !CUSTOMER_ID) return;
    let guestMonths = readLocal(GUEST_KEY);
    const hasGuest = (guestMonths || []).some(Boolean);
    if (!hasGuest) return;

    try {
      const headers = await getCacheHeaders();
      const url = `${API_BASE}/calendar/merge?customer_id=${CUSTOMER_ID}`;

      let r = await fetch(url, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ customer_id: CUSTOMER_ID, months: guestMonths })
      });
      
      if (r.status === 401) {
        await new Promise(resolve => setTimeout(resolve, 200));
        r = await fetch(url, {
          method: 'POST',
          headers: headers,
          body: JSON.stringify({ customer_id: CUSTOMER_ID, months: guestMonths })
        });
      }
      
      if (r.status === 401) {
        writeLocal(USER_KEY, guestMonths);
        geurkalender = guestMonths.slice(0,12).map(sanitizeItem);
        localStorage.removeItem(GUEST_KEY);
        localStorage.removeItem('geurkalender_guest_updated');
        localStorage.removeItem('geurkalender_guest_updated__ms');
        setTimeout(() => pushServerNow(), 2000);
        return;
      }
      
      if (!r.ok) return;
      const data = await r.json().catch(()=>null);
      if (!data || !Array.isArray(data.months)) return;

      geurkalender = data.months.slice(0,12).map(sanitizeItem);
      writeLocal(USER_KEY, geurkalender);

      lastServerUpdatedAtISO = data.updatedAt || null;
      lastServerUpdatedAtMS  = tsNum(lastServerUpdatedAtISO);
      writeUpdated(lastServerUpdatedAtISO, lastServerUpdatedAtMS);

      if (Array.isArray(data.labels)) {
        window.gkServerLabels = data.labels;
        writeCachedLabels(data.labels);
        labelsPreloaded = true;
      }

      localStorage.removeItem(GUEST_KEY);
      localStorage.removeItem('geurkalender_guest_updated');
      localStorage.removeItem('geurkalender_guest_updated__ms');

      renderKalender();
    } catch(_){}
  }

  /* ======================== Body scroll lock ======================== */
  function getScrollbarWidth(){ return window.innerWidth - document.documentElement.clientWidth; }
  function lockBodyScroll() {
    if (document.body.dataset.gkLocked === '1') return;
    const y = window.pageYOffset || document.documentElement.scrollTop || 0;
    const sbw = getScrollbarWidth();
    const prev = getComputedStyle(document.documentElement).scrollBehavior;
    document.documentElement.dataset.gkPrevScrollBehavior = prev || '';
    document.documentElement.style.scrollBehavior = 'auto';
    document.body.dataset.gkLocked = '1';
    document.body.dataset.gkScrollY = String(y);
    if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${y}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
  }
  
  function unlockBodyScroll() {
    if (document.body.dataset.gkLocked !== '1') return;
    const y = parseInt(document.body.dataset.gkScrollY || '0', 10) || 0;
    document.body.dataset.gkLocked = '0';
    document.body.removeAttribute('data-gk-scroll-y');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
    document.documentElement.style.scrollBehavior = 'auto';
    window.scrollTo({ top: y, left: 0, behavior: 'auto' });
    const prev = document.documentElement.dataset.gkPrevScrollBehavior || '';
    if (prev) document.documentElement.style.scrollBehavior = prev; else document.documentElement.style.scrollBehavior = '';
    delete document.documentElement.dataset.gkPrevScrollBehavior;
  }

  /* ======================== Overlay / history ======================== */
  let gkIgnoreDocClickUntil = 0;
  let gkAddDedupUntil = 0;

  // 🔥 REMOVED: Polling elke 12s is niet nodig
  // Focus/visibility events zijn voldoende voor sync
  // let pollTimer = null;
  // function startPolling(){ ... }
  // function stopPolling(){ ... }

  function isModalOpen(){ return !modal.classList.contains('hidden'); }
  
  async function showModalOnly(){
  if (!modal.classList.contains('hidden')) return;
  
  if (!history.state || !history.state.gkOpen) {
    try { history.pushState({ gkOpen: true }, '', location.href); } catch(e) {}
  }
  
  // 🔥 NEW: Version check (non-blocking, instant open!)
  const versionCheckPromise = IS_SUBSCRIBER ? ensureFreshCalendarData() : Promise.resolve(false);
  
  // Voor subscribers: zorg dat labels beschikbaar zijn
  if (IS_SUBSCRIBER && !labelsPreloaded && !isLoadingLabels) {
    const cachedLabels = readCachedLabels();
    if (!cachedLabels) {
      // Background load (non-blocking)
      preloadLabelsForSubscriber().then(() => {
        if (!modal.classList.contains('hidden')) {
          renderKalender();
        }
      }).catch(() => {});
    } else {
      window.gkServerLabels = cachedLabels;
      labelsPreloaded = true;
    }
  }
  
  // Open modal INSTANT (niet wachten!)
  modal.classList.remove('hidden');
  lockBodyScroll();
  gkIgnoreDocClickUntil = Date.now() + 400;
  // showDragHintIfNeeded();  // okt 2026 uitgezet (Leslie): tip stond over de titel en is zinloos bij een lege kalender
  renderKalender();  // Render met huidige data
  try { bindGkScrollHint(); } catch(e){}  // mobiele scroll-fade aansturen
  ensureGkMetaData();  // subtiele cyclus + wissel-deadline regel (alleen abonnees)
  try { fillGuestFirstShip(); } catch(e){}  // "wanneer komt mijn eerste parfum" voor niet-abonnees

  // Wacht op version check in background
  versionCheckPromise.then(wasUpdated => {
    if (wasUpdated && !modal.classList.contains('hidden')) {
      calLog('[MODAL] Calendar was updated, re-rendering...');
      renderKalender();
    }
  }).catch(e => {
    calError('[MODAL] Version check error:', e);
  });
  
  // 🔥 OPTIMIZED: Eén refresh is genoeg (version check hierboven doet al data fetch indien nodig)
  refreshFromServer();
  // REMOVED: setTimeout(refreshFromServer, 1600) - dubbele call niet nodig
  // REMOVED: startPolling() - focus/visibility events zijn voldoende
}
  
  async function closeModal(){
    if (modal.classList.contains('hidden')) return;

    if (dirty && SERVER_OK && !inflight) {
      const header = modal.querySelector('.geurkalender-header h2');
      const originalText = header ? header.textContent : '';
      
      if (header) {
        header.textContent = 'Opslaan...';
        header.style.opacity = '0.7';
      }
      
      const savePromise = pushServerNow();
      const timeoutPromise = new Promise(resolve => setTimeout(resolve, 800));
      
      try {
        await Promise.race([savePromise, timeoutPromise]);
      } catch(e) {
        calWarn('[Geurkalender] Save error:', e);
      }
      
      if (header) {
        header.textContent = originalText;
        header.style.opacity = '1';
      }
    }
      
    modal.classList.add('hidden');
    // REMOVED: stopPolling() - polling is verwijderd
    unlockBodyScroll();
    if (history.state && history.state.gkOpen) { 
      try { history.back(); } catch(e) {} 
    }
  }
  
  window.addEventListener('popstate', () => { if (isModalOpen()) { modal.classList.add('hidden'); unlockBodyScroll(); } });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && isModalOpen()) { e.preventDefault(); closeModal(); } });
  modal.addEventListener('contextmenu', (e) => { if (e.target.closest('.geurkalender-slot')) e.preventDefault(); }, { capture: true });

  /* ======================== UTC FREEZE LOGIC ======================== */
  function nowDate() {
    return window.smNowOverride ? new Date(window.smNowOverride) : new Date();
  }

  function freezeFor(cycle, ship) {
    const shipYear = ship.getFullYear();
    const shipMonth = ship.getMonth();
    
    if (cycle === '15') {
      return new Date(Date.UTC(shipYear, shipMonth, LOCK_DAY_C15, FREEZE_HOUR_UTC, 0, 0));
    } else {
      let freezeYear = shipYear;
      let freezeMonth = shipMonth - 1;
      if (freezeMonth < 0) {
        freezeMonth = 11;
        freezeYear -= 1;
      }
      return new Date(Date.UTC(freezeYear, freezeMonth, LOCK_DAY_C1, FREEZE_HOUR_UTC, 0, 0));
    }
  }

  function nextShipAfter(now, cycle) {
    const y = now.getFullYear(), m = now.getMonth();
    if (cycle === '15') {
      const fifteenth = new Date(y, m, SHIP_DAY_C15);
      return (now <= fifteenth) ? fifteenth : new Date(y, m + 1, SHIP_DAY_C15);
    } else {
      const firstThis = new Date(y, m, SHIP_DAY_C1);
      return (now <= firstThis) ? firstThis : new Date(y, m + 1, SHIP_DAY_C1);
    }
  }

  function firstEditableShipDate(cycle) {
    const now = nowDate();
    let ship = nextShipAfter(now, cycle);
    const fr = freezeFor(cycle, ship);
    if (now >= fr) {
      ship = (cycle === '15')
        ? new Date(ship.getFullYear(), ship.getMonth() + 1, SHIP_DAY_C15)
        : new Date(ship.getFullYear(), ship.getMonth() + 1, SHIP_DAY_C1);
    }
    return ship;
  }

  function resolveCycle() {
    if (window.smCustomerCycle === '1' || window.smCustomerCycle === '15') {
      return window.smCustomerCycle;
    }
    
    const now = nowDate();
    const y = now.getFullYear();
    const m = now.getMonth();
    
    const c15_cutoff = new Date(Date.UTC(y, m, LOCK_DAY_C15, SIGNUP_CUTOFF_HOUR_UTC, 0, 0));
    const c1_cutoff = new Date(Date.UTC(y, m, LOCK_DAY_C1, SIGNUP_CUTOFF_HOUR_UTC, 0, 0));

    const chosen = (now >= c15_cutoff && now < c1_cutoff) ? '1' : '15';
    
    window.smCustomerCycleResolved = chosen;
    return chosen;
  }

  function getNext12Months() {
    const cycle = resolveCycle();
    const startShip = firstEditableShipDate(cycle);
    const out = [];
    for (let i = 0; i < 12; i++) {
      const ship = (cycle === '15')
        ? new Date(startShip.getFullYear(), startShip.getMonth() + i, SHIP_DAY_C15)
        : new Date(startShip.getFullYear(), startShip.getMonth() + i, SHIP_DAY_C1);
      out.push(
        window.smDebugShowDay
          ? `${cycle === '15' ? SHIP_DAY_C15 : SHIP_DAY_C1} ${monthNames[ship.getMonth()]} ${ship.getFullYear()}`
          : `${monthNames[ship.getMonth()]} ${ship.getFullYear()}`
      );
    }
    return out;
  }

  /* ======================== Data & helpers ======================== */
  let geurkalender = readLocal(ACTIVE_KEY);
  // De laatste kalenderstand zoals we die van de server kenden. Bij het laden is
  // dat gelijk aan wat lokaal staat; alles wat de klant daarna toevoegt is een
  // nieuwe keuze. Nodig om na een lock te weten wat bewaard moet blijven.
  let laatstBekendeServerStand = readLocal(ACTIVE_KEY);
  let lastServerUpdatedAtISO = readUpdatedISO();
  let lastServerUpdatedAtMS  = readUpdatedMS();

  let inflight = false;
  let queued = false;
  let dirty = false;
  let ignoreExternalUntil = 0;

  // Stel de "lokale wijziging nog niet opgeslagen"-status beschikbaar voor externe
  // syncs (de header-badge poll + de sticky-bar reconcile). Zolang dit true is mogen
  // zij localStorage NIET overschrijven met server-data, anders zet een trage/koude
  // backend je net-gewijzigde geur ~seconden terug (de 30s flip-back). Dit is exact
  // dezelfde guard die refreshFromServer hieronder al voor zichzelf gebruikt.
  try { window.__gkSavePending = function () { return !!(inflight || dirty || queued); }; } catch (_) {}

  function normalizeLeftPack() {
    geurkalender = (geurkalender || []).filter(Boolean);
    while (geurkalender.length < 12) geurkalender.push(null);
  }

  // De kalender is 'klaar' zodra de serverstand is overgenomen. Vóór dat moment
  // kan de lokale lijst nog leeg zijn terwijl de klant wél geuren heeft, en mag
  // niemand daar conclusies aan verbinden (de hero op de homepage deed dat wel,
  // en sprong dan ten onrechte op 'je geurkalender is nog leeg').
  function markeerKalenderKlaar() {
    try {
      window.__gkReady = true;
      document.dispatchEvent(new CustomEvent('gk:months-changed', { detail: geurkalender }));
    } catch (_) {}
  }

  function saveKalender(persist = true){
    normalizeLeftPack();
    writeLocal(ACTIVE_KEY, geurkalender);
    if (persist) schedulePersist();
    try { document.dispatchEvent(new CustomEvent('gk:months-changed', { detail: geurkalender })); } catch(_) {}
  }
  
  function firstEmptyIndex(arr){ const i = arr.findIndex(v => !v); return i === -1 ? arr.length : i; }
  
  function sanitizeItem(it){
    if (!it) return null;
    return { title: it.title || 'Product', img: it.img || '', brand: it.brand || '', url: it.url || '#', variantId: it.variantId || undefined };
  }

  // Voegt ALLEEN de geuren die de klant zelf net heeft toegevoegd terug in een
  // verse serverstand. Dat is het verschil tussen wat er lokaal staat en de
  // laatste stand die we van de server kenden (`basis`).
  //
  // Waarom niet gewoon alles wat lokaal staat: na een lock is de geur van deze
  // maand verzonden en uit de kalender gehaald. Die staat lokaal nog wél. Zou je
  // alles terugzetten, dan komt een zojuist verzonden geur opnieuw in de agenda.
  // De server wint altijd per maand, dus het opschuiven wordt nooit ongedaan
  // gemaakt; nieuwe keuzes schuiven door naar de eerste vrije maand.
  function mergeKeepingLocalPicks(server, local, basis) {
    const uit = (server || []).slice(0, 12);
    while (uit.length < 12) uit.push(null);
    const sleutel = (it) => String((it && (it.variantId || it.title)) || '');
    const lokaleSleutels = new Set((local || []).filter(Boolean).map(sleutel));
    const albekendVanServer = new Set((basis || []).filter(Boolean).map(sleutel));

    // Wat de klant zojuist heeft WEGGEHAALD: stond in de vorige serverstand,
    // staat lokaal niet meer. Die halen we ook uit de verse serverstand, anders
    // zou een verwijdering (of een wissel) ongedaan gemaakt worden.
    const verwijderd = new Set(
      [...albekendVanServer].filter((k) => !lokaleSleutels.has(k))
    );
    for (let i = 0; i < uit.length; i++) {
      if (uit[i] && verwijderd.has(sleutel(uit[i]))) uit[i] = null;
    }

    const bekend = new Set(uit.filter(Boolean).map(sleutel));
    (local || []).forEach((it) => {
      if (!it) return;
      const k = sleutel(it);
      if (!k || bekend.has(k)) return;
      if (albekendVanServer.has(k)) return;  // stond al op de server = geen nieuwe keuze
      const vrij = uit.findIndex((v) => !v);
      if (vrij === -1) return;
      uit[vrij] = it;
      bekend.add(k);
    });
    return uit;
  }

  // Haalt de verse serverstand op en voegt de meegegeven keuzes daar weer in.
  // Retourneert true als dat gelukt is.
  async function syncMetServer(lokaleKeuzes) {
    const url = `${API_BASE}/calendar?customer_id=${encodeURIComponent(CUSTOMER_ID)}&_=${Date.now()}`;
    const headers = await getCacheHeaders();
    const resp = await fetch(url, { cache: 'no-store', headers: headers });
    if (!resp.ok) return false;
    const data = await resp.json();
    const server = Array.isArray(data.months) ? data.months.slice(0, 12).map(sanitizeItem) : [];
    geurkalender = mergeKeepingLocalPicks(server, lokaleKeuzes, laatstBekendeServerStand);
    laatstBekendeServerStand = server;
    window.__gkReady = true;
    saveKalender(false);
    if (data.version) {
      localStorage.setItem(`gk_version_${CUSTOMER_ID}`, String(data.version));
    }
    if (data.updatedAt) {
      lastServerUpdatedAtISO = data.updatedAt;
      lastServerUpdatedAtMS = tsNum(data.updatedAt);
      writeUpdated(lastServerUpdatedAtISO, lastServerUpdatedAtMS);
    }
    renderKalender();
    return true;
  }

  // 🎁 Check if variant is blocked (surcharge product for gift customer)
  function isVariantBlocked(variantId) {
    if (!isGiftSubscription || !variantId) return false;
    return blockedVariantIds.has(String(variantId));
  }

  // 🎁 Load gift subscription status and blocked variants
  async function loadGiftBlockStatus() {
    if (!SERVER_OK || !CUSTOMER_ID) return;

    try {
      const headers = await getCacheHeaders();
      const resp = await fetch(
        `${API_BASE}/subscription/status?customer_id=${CUSTOMER_ID}&_=${Date.now()}`,
        { cache: 'no-store', headers: headers }
      );

      if (!resp.ok) return;

      const data = await resp.json();
      if (data.ok && data.data) {
        isGiftSubscription = !!data.data.is_gift;

        // 🔥 Cache to localStorage for instant load on next visit
        if (GIFT_CACHE_KEY) {
          try {
            localStorage.setItem(GIFT_CACHE_KEY, isGiftSubscription ? 'true' : 'false');
          } catch(_) {}
        }

        if (isGiftSubscription && Array.isArray(data.data.blocked_variant_ids)) {
          const variants = data.data.blocked_variant_ids.map(String);
          blockedVariantIds = new Set(variants);

          // Cache blocked variants
          if (BLOCKED_CACHE_KEY) {
            try {
              localStorage.setItem(BLOCKED_CACHE_KEY, JSON.stringify(variants));
            } catch(_) {}
          }

          calLog('[GIFT] Loaded blocked variants:', blockedVariantIds.size);
        } else if (BLOCKED_CACHE_KEY) {
          // Clear cache if not a gift subscription
          try {
            localStorage.removeItem(BLOCKED_CACHE_KEY);
          } catch(_) {}
        }
      }
    } catch (e) {
      calError('[GIFT] Error loading gift status:', e);
    }
  }

  /* ======================== 🔥 Preload labels ======================== */
  async function preloadLabelsForSubscriber() {
    if (!IS_SUBSCRIBER || !SERVER_OK) return;
    
    const cached = readCachedLabels();
    if (cached && !checkIfShouldRefreshLabels()) {
      window.gkServerLabels = cached;
      labelsPreloaded = true;
      return;
    }
    
    try {
      const url = API_BASE + '/calendar?customer_id=' + encodeURIComponent(CUSTOMER_ID) + '&_=' + Date.now();
      const headers = await getCacheHeaders();
      const response = await fetch(url, {
        cache: 'no-store',
        headers: headers
      });
      
      if (response.ok) {
        const data = await response.json();
        
        if (Array.isArray(data.labels) && data.labels.length > 0) {
          window.gkServerLabels = data.labels;
          writeCachedLabels(data.labels);
          labelsPreloaded = true;
          
          // Update last refresh timestamp
          try {
            localStorage.setItem(LAST_REFRESH_KEY, String(Date.now()));
          } catch(_) {}
        }
        
        if (Array.isArray(data.months)) {
          const server = data.months.slice(0, 12).map(sanitizeItem);
          const serverISO = data.updatedAt || null;
          const serverTS  = tsNum(serverISO);
          
          if (serverTS > lastServerUpdatedAtMS) {
            geurkalender = server;
            lastServerUpdatedAtISO = serverISO;
            lastServerUpdatedAtMS = serverTS;
            writeUpdated(lastServerUpdatedAtISO, lastServerUpdatedAtMS);
            saveKalender(false);
          }
        }
      }
    } catch(e) {
      calError('[Geurkalender] Labels preload error:', e);
    }
  }

  /* ======== SERVER I/O ======== */
  let persistTimer = null;
  function schedulePersist() {
    if (!SERVER_OK) return;
    clearTimeout(persistTimer);
    persistTimer = setTimeout(pushServerNow, 50);
  }

  async function doSaveSnapshot(snapshot, clientIso) {
    const payload = { customer_id: CUSTOMER_ID, months: snapshot, clientUpdatedAt: clientIso || null };
    const headers = await getAuthHeaders();
    const r = await fetch(API_BASE + '/calendar/save', {
      method: 'POST',
      headers: headers,
      keepalive: true,
      body: JSON.stringify(payload)
    });
    if (r.status === 409) {
      const data = await r.json().catch(()=>null);
      const srvISO = data && data.updatedAt || null;
      if (srvISO) {
        lastServerUpdatedAtISO = srvISO;
        lastServerUpdatedAtMS  = tsNum(srvISO);
        writeUpdated(lastServerUpdatedAtISO, lastServerUpdatedAtMS);
      }
      return { ok:false, conflict:true };
    }
    if (r.ok) {
      const data = await r.json().catch(()=>null);
      const srvISO = data && data.updatedAt || null;
      if (srvISO) {
        lastServerUpdatedAtISO = srvISO;
        lastServerUpdatedAtMS  = tsNum(srvISO);
        writeUpdated(lastServerUpdatedAtISO, lastServerUpdatedAtMS);
      }
      return { ok:true };
    }
    return { ok:false, conflict:false };
  }

  async function pushServerNow(){
  if (!SERVER_OK) return false;

  if (inflight) { queued = true; return false; }
  inflight = true;

  let snapshot = (geurkalender || []).slice(0,12).map(sanitizeItem);

  // 🔥 Versienummer verversen VÓÓR het opslaan.
  // Een klant die voor het eerst terugkomt na een lock heeft nog het oude
  // versienummer in localStorage staan (dat werd alleen bijgewerkt bij het
  // openen van de kalender-popup, en dan ook nog non-blocking). Zonder deze
  // check wordt zijn eerste save altijd geweigerd en moet hij opnieuw kiezen.
  // Faalt de check om welke reden dan ook, dan slaan we gewoon op zoals
  // voorheen: dit mag een save nooit tegenhouden.
  if (IS_SUBSCRIBER && !pushServerNow._versionRetried) {
    try {
      const vHeaders = await getCacheHeaders();
      const vResp = await fetch(
        `${API_BASE}/calendar/version?customer_id=${encodeURIComponent(CUSTOMER_ID)}&cycle=${window.smCustomerCycle || '15'}&_=${Date.now()}`,
        { cache: 'no-store', headers: vHeaders }
      );
      if (vResp.ok) {
        const vData = await vResp.json();
        const serverVersion = parseInt(vData.version || 0);
        const lokaleVersie = parseInt(localStorage.getItem(`gk_version_${CUSTOMER_ID}`) || '0');
        if (serverVersion > lokaleVersie) {
          calLog(`[SAVE] Versie liep achter (${lokaleVersie} → ${serverVersion}), eerst synchroniseren`);
          if (await syncMetServer(snapshot)) {
            snapshot = (geurkalender || []).slice(0,12).map(sanitizeItem);
          }
        }
      }
    } catch(e) {
      calError('[SAVE] Versiecheck vooraf faalde, gewoon doorgaan:', e);
    }
  }

  // 🔥 NEW: Get current version (na de sync hierboven, dus altijd actueel)
  const currentVersion = parseInt(localStorage.getItem(`gk_version_${CUSTOMER_ID}`) || '0');

  let result = { ok:false, conflict:false };
  try {
    const headers = await getAuthHeaders();

    // Geen geldig token? Dan de save UITSTELLEN in plaats van hem te verbranden
    // op een gegarandeerde 401. De keuze van de klant blijft lokaal staan en
    // gaat alsnog naar de server zodra het token binnen is.
    if (CUSTOMER_ID && !headers['X-Shopify-Customer-Token']) {
      pushServerNow._tokenWacht = (pushServerNow._tokenWacht || 0) + 1;
      inflight = false;
      dirty = true;
      if (pushServerNow._tokenWacht <= 5) {
        calError(`[SAVE] Nog geen token, save uitgesteld (poging ${pushServerNow._tokenWacht})`);
        setTimeout(pushServerNow, 1500);
      } else {
        calError('[SAVE] Nog steeds geen token, opslaan gestopt (keuze staat lokaal)');
        pushServerNow._tokenWacht = 0;
      }
      return false;
    }
    pushServerNow._tokenWacht = 0;

    const response = await fetch(API_BASE + '/calendar/save', {
      method: 'POST',
      headers: headers,
      keepalive: true,
      body: JSON.stringify({
        customer_id: CUSTOMER_ID,
        months: snapshot,
        clientUpdatedAt: lastServerUpdatedAtISO || null,
        version: currentVersion  // 🔥 NEW
      })
    });
    
    // 🔥 Handle 401 (JWT invalid)
    if (response.status === 401) {
      clearJwtCache();
      calError('[SAVE] 401 Unauthorized - JWT cache cleared');
    }

    // 🔥 Handle stale data conflict (409)
    // clientUpdatedAt is ouder dan de laatste lock. Haal ALLEEN de verse
    // timestamp op, behoud lokale kalenderdata, en retry de save.
    if (response.status === 409) {
      const conflict = await response.json().catch(() => null);
      const reason = (conflict && conflict.error) || '';
      inflight = false;

      // version_conflict = er is een lock geweest sinds deze pagina de kalender ophaalde.
      // De kalender is dan opgeschoven en de lokale data is écht verouderd. Server-state
      // overnemen in plaats van hem met een retry terugduwen: die retry hoogde de lokale
      // versie op en zette daarmee juist de zombie-bescherming buiten werking.
      if (reason === 'version_conflict') {
        calLog('[SAVE] 409 version_conflict - serverstand ophalen, keuze behouden, opnieuw opslaan');
        pushServerNow._409retried = false;
        try {
          if (await syncMetServer(snapshot) && !pushServerNow._versionRetried) {
            // Eén automatische herkansing met het verse versienummer, zodat de
            // klant zijn geur niet opnieuw hoeft te kiezen.
            pushServerNow._versionRetried = true;
            dirty = true;
            queued = false;
            setTimeout(pushServerNow, 150);
            return false;
          }
        } catch(e) {
          calError('[SAVE] Verversen na version_conflict faalde:', e);
        }
        pushServerNow._versionRetried = false;
        dirty = false;
        return false;
      }

      calLog('[SAVE] 409 stale_data - fetching fresh timestamp, keeping local data...');

      // Haal verse timestamp op zonder lokale data te overschrijven
      try {
        const tsUrl = `${API_BASE}/calendar?customer_id=${encodeURIComponent(CUSTOMER_ID)}&_=${Date.now()}`;
        const tsHeaders = await getCacheHeaders();
        const tsResp = await fetch(tsUrl, { cache: 'no-store', headers: tsHeaders });
        if (tsResp.ok) {
          const tsData = await tsResp.json();
          if (tsData.updatedAt) {
            lastServerUpdatedAtISO = tsData.updatedAt;
            lastServerUpdatedAtMS = tsNum(tsData.updatedAt);
            writeUpdated(lastServerUpdatedAtISO, lastServerUpdatedAtMS);
          }
          if (tsData.version) {
            localStorage.setItem(`gk_version_${CUSTOMER_ID}`, String(tsData.version));
          }
        }
      } catch(e) {
        calError('[SAVE] Failed to fetch fresh timestamp:', e);
      }

      // Retry save 1x met verse timestamp
      if (!pushServerNow._409retried) {
        pushServerNow._409retried = true;
        calLog('[SAVE] Retrying save with fresh timestamp...');
        dirty = true;
        queued = false;
        setTimeout(pushServerNow, 200);
      } else {
        calLog('[SAVE] 409 retry already attempted, saving locally only');
        pushServerNow._409retried = false;
        dirty = false;
      }
      return false;
    } else if (response.ok) {
    const data = await response.json().catch(() => null);
    const srvISO = data && data.updatedAt || null;
    
    // 🔥 FIX: Update version after successful save
    if (data && data.version) {
        localStorage.setItem(`gk_version_${CUSTOMER_ID}`, String(data.version));
        calLog('[SAVE] Version updated to:', data.version);
    }
    pushServerNow._versionRetried = false;
    // Deze stand staat nu op de server: vanaf hier telt alleen nieuwe input als
    // nieuwe keuze.
    laatstBekendeServerStand = (data && Array.isArray(data.months))
      ? data.months.slice(0, 12).map(sanitizeItem)
      : snapshot;

    if (srvISO) {
        lastServerUpdatedAtISO = srvISO;
        lastServerUpdatedAtMS = tsNum(srvISO);
        writeUpdated(lastServerUpdatedAtISO, lastServerUpdatedAtMS);
    }
    result = { ok: true };
}
  } catch(e) {
    calError('[SAVE] Error:', e);
  }

  inflight = false;
  if (result.ok) {
    dirty = false;
  }
  if (queued) { queued = false; setTimeout(pushServerNow, 0); }

    if (!result.ok) {
      try {
        const raw = JSON.stringify({ customer_id: CUSTOMER_ID, months: snapshot, clientUpdatedAt: lastServerUpdatedAtISO || null });
        if (navigator.sendBeacon) {
          const blob = new Blob([raw], { type: 'text/plain;charset=UTF-8' });
          navigator.sendBeacon(API_BASE + '/calendar/save', blob);
        } else {
          fetch(API_BASE + '/calendar/save', { method:'POST', mode:'no-cors', keepalive:true, headers:{'Content-Type':'text/plain;charset=UTF-8'}, body: raw });
        }
      } catch(_){}
    }
    return result.ok;
  }

  // 🔥 Inflight guard voor refreshFromServer
  let refreshInflight = false;

  async function refreshFromServer() {
    if (!SERVER_OK) return;
    if (Date.now() < ignoreExternalUntil) return;
    if (inflight || dirty) return;

    // 🔥 Prevent parallel refresh calls
    if (refreshInflight) {
      calLog('[CALENDAR] Refresh already in progress, skipping...');
      return;
    }
    refreshInflight = true;

    try {
        const url = `${API_BASE}/calendar?customer_id=${encodeURIComponent(CUSTOMER_ID)}&_=${Date.now()}`;

        calLog(`[CALENDAR] Refreshing from server (subscriber=${IS_SUBSCRIBER})...`);

        const headers = await getCacheHeaders();
        const response = await fetch(url, {
            cache: 'no-store',
            headers: headers
        });
        
        if (!response.ok) {
            // 🔥 401 = JWT invalid, clear cache voor volgende poging
            if (response.status === 401) {
                clearJwtCache();
            }
            calError('[CALENDAR] Server refresh failed:', response.status);
            return;
        }
        
        const data = await response.json();
        
        if (!data || !Array.isArray(data.months)) {
            calError('[CALENDAR] Invalid response:', data);
            return;
        }
        
        calLog(`[CALENDAR] Data loaded from: ${data.source || 'unknown'}`);
        
        // 🔥 NEW: Check if labels changed
        const labelsChanged = !window.gkServerLabels || 
                              JSON.stringify(window.gkServerLabels) !== JSON.stringify(data.labels);
        
        if (Array.isArray(data.labels) && data.labels.length > 0) {
            window.gkServerLabels = data.labels;
            writeCachedLabels(data.labels);
            labelsPreloaded = true;
            
            calLog('[CALENDAR] Labels updated:', data.labels.slice(0, 3));
            
            try {
                localStorage.setItem(LAST_REFRESH_KEY, String(Date.now()));
            } catch(_) {}
        }
        
        const server = data.months.slice(0, 12).map(sanitizeItem);
        const serverISO = data.updatedAt || null;
        const serverTS  = tsNum(serverISO);

        // Overschrijf de lokale geuren ALLEEN als de server ECHT nieuwer is (bv. na
        // een lock of een wijziging op een ander device).
        //
        // ⚠️ NIET meer op "labelsChanged" overschrijven: window.gkServerLabels is op
        // ELKE verse paginalading leeg, dus labelsChanged is dan altijd true. De oude
        // conditie (... || labelsChanged) overschreef daardoor bij elke navigatie de
        // lokale geuren met de backend — en als die net verouderd was (geur net op een
        // vorige pagina toegevoegd, save nog onderweg), stond de kalender ineens leeg.
        // Bij enkel gewijzigde labels re-renderen we alleen, met behoud van je geuren.
        if (serverTS > lastServerUpdatedAtMS) {
    calLog('[CALENDAR] Server is nieuwer → lokale state bijgewerkt vanaf server');

    geurkalender = server;
    lastServerUpdatedAtISO = serverISO;
    lastServerUpdatedAtMS = serverTS;
    writeUpdated(lastServerUpdatedAtISO, lastServerUpdatedAtMS);

    // 🔥 FIX: Update version from server
    if (data.version) {
        localStorage.setItem(`gk_version_${CUSTOMER_ID}`, String(data.version));
        calLog('[REFRESH] Version updated to:', data.version);
    }

    saveKalender(false);
    renderKalender();
} else if (labelsChanged) {
    // Alleen de maand-labels veranderden (bv. eerste fetch van deze pagina): NIET
    // de geuren overschrijven — die kunnen verser zijn dan de backend. Alleen
    // opnieuw renderen zodat de nieuwe labels zichtbaar worden.
    calLog('[CALENDAR] Alleen labels gewijzigd → re-render, lokale geuren behouden');
    renderKalender();
}
        // FIX (2026-05-15): "else if (serverTS < lastServerUpdatedAtMS) pushServerNow()" branch
        // verwijderd. Backend heeft een ~350ms gap tussen DB stored CURRENT_TIMESTAMP en
        // de save-response's datetime.now() — daardoor zat lokaal altijd ~350ms vóór op
        // server, en pushte smellish.nl elke refresh ongevraagd zijn state terug. Dit
        // overschreef edits van andere clients (zoals headless).
        // Echte unsaved local changes worden alsnog gepersisteerd via user actions,
        // closeModal, beforeunload en pagehide — dus geen functionaliteit verloren.
    } catch(e) {
        calError('[CALENDAR] Refresh error:', e);
    } finally {
        // 🔥 Always reset inflight guard
        refreshInflight = false;
    }
}

  async function saveToServer(payload) {
    try {
        const res = await fetch('/calendar/save', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });
        
        if (res.status === 409) {
            const data = await res.json();
            if (data.error === 'stale_data') {
                calLog('[CALENDAR] Stale data detected - refreshing...');
                
                // 🔥 Auto-refresh from server
                await refreshFromServer();
                
                // Optional: Show user-friendly message
                // alert('Je kalender is bijgewerkt. De nieuwste versie wordt getoond.');
                
                return;
            }
        }
        
        // ... rest van save logic
    } catch (e) {
        calError('[CALENDAR SAVE] Error:', e);
    }
  }
  // Fallback to Shopify if PostgreSQL fails
  async function refreshFromShopify() {
    try {
        const url = `${API_BASE}/calendar?customer_id=${encodeURIComponent(CUSTOMER_ID)}&_=${Date.now()}`;
        const headers = await getCacheHeaders();
        const response = await fetch(url, { cache: 'no-store', headers: headers });
        
        if (!response.ok) return;
        
        const data = await response.json();
        
        if (data && Array.isArray(data.months)) {
            calLog('[CALENDAR] Fallback to Shopify successful');
            
            const server = data.months.slice(0, 12).map(sanitizeItem);
            const serverISO = data.updatedAt || null;
            const serverTS  = tsNum(serverISO);
            
            if (serverTS > lastServerUpdatedAtMS) {
                geurkalender = server;
                lastServerUpdatedAtISO = serverISO; 
                lastServerUpdatedAtMS = serverTS; 
                writeUpdated(lastServerUpdatedAtISO, lastServerUpdatedAtMS);
                
                saveKalender(false); 
                renderKalender();
            }
        }
    } catch(e) {
        calError('[CALENDAR] Shopify fallback failed:', e);
    }
  } 


  /* ===== Subtiele cyclus + wissel-deadline regel onder "Aankomende parfums" =====
     Alleen voor abonnees. Hergebruikt /subscription/status (zelfde bron als de CTA/mijn-abonnement),
     dus pauze- en auto-restore-bewust. Niet-abonnees houden enkel "Aankomende parfums". */
  let _gkMetaFetching = false;
  let _gkInfo = null; // { frozen, deadlineText, shipText }
  const GK_META_CACHE_KEY = CUSTOMER_ID ? ('gk_meta_dl_' + CUSTOMER_ID) : null;

  function _gkReadMetaCache() {
    try { return GK_META_CACHE_KEY ? JSON.parse(localStorage.getItem(GK_META_CACHE_KEY) || 'null') : null; }
    catch (e) { return null; }
  }
  function _gkWriteMetaCache(v) {
    try { if (GK_META_CACHE_KEY) localStorage.setItem(GK_META_CACHE_KEY, JSON.stringify(v)); } catch (e) {}
  }

  function _gkFormatDate(iso) {
    try { return new Date(iso).toLocaleDateString('nl-NL', { day: 'numeric', month: 'long' }); }
    catch (e) { return null; }
  }

  // Verzendgroep heet naar de verzenddag (9 of 25), zelfde naam als FAQ, Mijn abonnement en welkomstmail.
  function _gkRondeNaam() {
    const cyc = (_gkInfo && _gkInfo.cycle) || window.smCustomerCycle;
    return 'Verzendgroep ' + ((cyc === '15') ? SHIP_DAY_C15 : SHIP_DAY_C1);
  }
  function _gkCycleFallback() {
    const cyc = (_gkInfo && _gkInfo.cycle) || window.smCustomerCycle;
    return 'Verzending rond de ' + ((cyc === '15') ? SHIP_DAY_C15 : SHIP_DAY_C1) + 'e van de maand';
  }
  // Eerstvolgende lockmoment (13:00 UTC = 15:00 zomer / 14:00 winter) voor een cyclus; voor
  // "Geur wisselen kan tot 24 september 15:00 uur" op Mijn abonnement en het accountoverzicht.
  function smNextLockMoment(cycle) {
    var lockDay = (String(cycle) === '15') ? LOCK_DAY_C15 : LOCK_DAY_C1;
    var now = new Date(), Y = now.getUTCFullYear(), M = now.getUTCMonth();
    var d = new Date(Date.UTC(Y, M, lockDay, FREEZE_HOUR_UTC));
    if (d.getTime() <= now.getTime()) d = new Date(Date.UTC(Y, M + 1, lockDay, FREEZE_HOUR_UTC));
    return d;
  }
  window.smNextLockMoment = smNextLockMoment;
  window.smLockMomentLabel = function (cycle) {   // "24 september 15:00 uur"
    var d = smNextLockMoment(cycle);
    return smFmtDateNl(d) + ' ' + smFmtTimeNl(d) + ' uur';
  };
  // Locktijd in NL-tijd bij een deadline-ISO (backend geeft freeze - 1 minuut, dus +1 min = 15:00/14:00).
  function _gkLockTimeLabel(iso) {
    try {
      const d = new Date(new Date(iso).getTime() + 60000);
      return d.toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Amsterdam' });
    } catch (e) { return ''; }
  }

  // Tooltip-inhoud: verzendgroep + verzenddatum + wijzig-deadline (of nette fallback vóór de fetch).
  function _gkTooltipHtml() {
    if (_gkInfo && _gkInfo.shipText) {
      const ship = _gkInfo.firstShipText
        ? 'Je eerste parfum versturen we rond ' + _gkInfo.firstShipText
        : 'Volgende verzending rond ' + _gkInfo.shipText;
      const tijd = _gkInfo.deadlineIso ? _gkLockTimeLabel(_gkInfo.deadlineIso) : '';
      const action = _gkInfo.frozen
        ? 'Deze staat al vast'
        : (_gkInfo.deadlineText ? 'Aanpassen kan tot ' + _gkInfo.deadlineText + (tijd ? ', ' + tijd + ' uur' : '') : '');
      return '<span class="gk-tip-line">' + ship + '</span>'
        + (action ? '<span class="gk-tip-line gk-tip-action">' + action + '</span>' : '');
    }
    return '<span class="gk-tip-line">' + _gkCycleFallback() + '</span>';
  }

  // (i) naast "Aankomende parfums" — verzend- + wijzig-info achter de tooltip.
  function renderGkInfo() {
    const subtitle = document.querySelector('.geurkalender-subtitle');
    if (!subtitle) return;
    let btn = subtitle.querySelector('.gk-info');
    // Geen abonnee-data (gast / niet-abonnee / nog niet geladen) → geen (i).
    if (!_gkInfo) { if (btn) btn.remove(); return; }
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'gk-info';
      btn.setAttribute('aria-label', 'Verzend- en wijzig-informatie');
      btn.innerHTML = '<span class="gk-info-i" aria-hidden="true">i</span><span class="gk-info-tip" role="tooltip"></span>';
      btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); btn.classList.toggle('is-open'); });
      subtitle.appendChild(btn);
    }
    const tip = btn.querySelector('.gk-info-tip');
    if (tip) tip.innerHTML = _gkTooltipHtml();
  }
  // Sluit een open tooltip bij klik elders (één keer geregistreerd).
  document.addEventListener('click', function () {
    document.querySelectorAll('.gk-info.is-open, .gk-first.is-open').forEach(function (el) {
      el.classList.remove('is-open');
    });
  });

  async function ensureGkMetaData() {
    // De (i) "Volgende verzending"-tooltip is UITSLUITEND voor echte abonnees.
    // Niet-abonnees (gast + prospect) hebben al de "Wanneer komt mijn eerste
    // parfum?"-hint (fillGuestFirstShip, gelijk aan de eerste kalendermaand), dus
    // hier geen dubbele datum.
    // Abonnee-bepaling IDENTIEK aan de sticky CTA / hero (zelfde signalen, met
    // /subscription/status als autoriteit): sla de tooltip alleen over als er een
    // ECHTE Shopify-sessie is én de server zeker weet "geen abonnee"
    // (smJwtRecovered !== true && smIsSubscriber === false). Bij JWT-recovery
    // (sessie verlopen, JWT nog geldig) is smIsSubscriber onbetrouwbaar, dus dan
    // fetchen we wél en laat de server beslissen, zodat een abonnee met verlopen
    // sessie de tooltip nooit mist. Stale abonnee-meta-cache wissen we direct.
    if (window.smJwtRecovered !== true && window.smIsSubscriber === false) {
      _gkInfo = null;
      try { if (GK_META_CACHE_KEY) localStorage.removeItem(GK_META_CACHE_KEY); } catch (e) {}
      renderGkInfo();
      return;
    }

    // Abonnee: echte volgende BEWERKBARE zending uit /subscription/status
    // (pauze-/consumptie-bewust). Klant-id is client-side hersteld via de 365d-JWT,
    // zodat dit ook werkt bij verlopen Shopify-sessie, net als de CTA.
    const cid = window.smCustomerId || CUSTOMER_ID;
    if (!cid) return;
    if (!_gkInfo) _gkInfo = _gkReadMetaCache();
    renderGkInfo();
    if (_gkMetaFetching) return;
    _gkMetaFetching = true;
    try {
      let token = '';
      try {
        if (typeof window.getCustomerJWTToken === 'function') token = await window.getCustomerJWTToken(cid);
      } catch (e) {}
      const headers = { 'Content-Type': 'application/json' };
      if (token) headers['X-Shopify-Customer-Token'] = token;
      const res = await fetch(`${API_BASE}/subscription/status?customer_id=${encodeURIComponent(cid)}&_=${Date.now()}`, { headers, cache: 'no-store' });
      if (!res.ok) throw new Error('subscription/status ' + res.status);
      const json = await res.json();
      const data = (json && json.data) ? json.data : json;
      // Reconcile de gast-hint met de server-waarheid (vooral bij JWT-recovery,
      // waar de synchrone gok nog onzeker was): echte abonnee → verberg de hint,
      // anders → toon de "Wanneer komt mijn eerste parfum?"-hint.
      try { gkApplyFirstShipVisibility(!!(data && data.has_subscription)); } catch (e) {}
      const slot = (data && Array.isArray(data.next_slots) && data.next_slots.length) ? data.next_slots[0] : null;
      if (slot) {
        const dlIso = slot.deadline || slot.deadlineDate || null;
        const shipIso = slot.shippingDate || slot.shipDate || null;
        _gkInfo = {
          frozen: !!slot.is_frozen,
          deadlineText: dlIso ? _gkFormatDate(dlIso) : null,
          deadlineIso: dlIso || null,
          shipText: shipIso ? _gkFormatDate(shipIso) : null,
          // Nieuwe klant: eerste doos gaat op lock + 8 (backend first_ship_date), niet op de verzenddag.
          firstShipText: (data && data.first_ship_date) ? _gkFormatDate(data.first_ship_date) : null,
          cycle: data && data.cycle
        };
      } else {
        _gkInfo = null; // geen abonnement / geen bewerkbare zending → geen tooltip
      }
      _gkWriteMetaCache(_gkInfo);
    } catch (e) {
      // stil falen — gecachte info blijft
    } finally {
      _gkMetaFetching = false;
    }
    renderGkInfo();
  }

  /* ===== "Wanneer komt mijn eerste parfum?" — alleen niet-abonnees =====
     Spiegelt de backend cycle-bepaling (auth/app.py determineActualCycle):
     signup-cutoff 12:00 UTC op de 24e (→ cycle 1, 9e v/d maand) en de 10e
     (→ cycle 15, de 25e). Tijden in NL-tijd zodat ze kloppen incl. zomertijd. */
  // Eerste zending bij een lockmoment: lock + 8 dagen; weekend en 1 jan / 25-26 dec schuiven
  // door naar de eerstvolgende werkdag. Kopie van kalender/timing_config.py first_ship_date().
  function smFirstShipFromLock(lockDate) {
    var d = new Date(lockDate.getTime() + FIRST_SHIP_EARLIEST_DAYS_AFTER_LOCK * 86400000);
    d.setUTCHours(0, 0, 0, 0);
    var skipDay = function (x) {
      var m = x.getUTCMonth() + 1, dd = x.getUTCDate(), wd = x.getUTCDay();
      return wd === 0 || wd === 6 || (m === 1 && dd === 1) || (m === 12 && (dd === 25 || dd === 26));
    };
    while (skipDay(d)) d.setUTCDate(d.getUTCDate() + 1);
    return d;
  }
  function smFmtDateNl(d) {
    try { return d.toLocaleDateString('nl-NL', { day: 'numeric', month: 'long', timeZone: 'Europe/Amsterdam' }); }
    catch (e) { return ''; }
  }
  function smFmtTimeNl(d) {
    try { return d.toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Amsterdam' }); }
    catch (e) { return ''; }
  }

  // Per verzendgroep (9 en 25) de eerstvolgende sluiting van de aanmelding en de bijbehorende
  // eerste-verzenddatum. Vult de FAQ-blokken "Verzendgroep 9 (aanmelden sluit op ...)" met
  // concrete data i.p.v. "de 24e" / "de 2e van de maand erna".
  function computeRoundDates() {
    var now = new Date();
    var CUT = 12; // SIGNUP_CUTOFF_HOUR_UTC
    function nextLock(lockDay) {
      var Y = now.getUTCFullYear(), M = now.getUTCMonth();
      var d = new Date(Date.UTC(Y, M, lockDay, CUT));
      if (d.getTime() <= now.getTime()) d = new Date(Date.UTC(Y, M + 1, lockDay, CUT));
      return d;
    }
    function build(ronde, lockDay) {
      var lock = nextLock(lockDay);
      var lockMoment = new Date(lock.getTime() + 3600000); // lock/freeze = 13:00 UTC, een uur na de aanmeldgrens
      return {
        ronde: ronde, lock: lock, lockDay: lockDay,
        sluitLabel: smFmtDateNl(lock) + ' om ' + smFmtTimeNl(lock) + ' uur',
        sluitKort: smFmtDateNl(lock) + ' ' + smFmtTimeNl(lock),   // "24 september 14:00"
        eersteLabel: smFmtDateNl(smFirstShipFromLock(lock)),
        // "t/m 24 september 15:00 uur" (wisseldeadline = lockmoment, DST-bestendig)
        wisselKort: 't/m ' + smFmtDateNl(lockMoment) + ' ' + smFmtTimeNl(lockMoment) + ' uur',
        wisselLabel: 't/m ' + smFmtDateNl(lockMoment) + ' ' + smFmtTimeNl(lockMoment) + ' uur, daarna elke maand t/m de ' + lockDay + 'e',
        // Homepage (data-sm-compact): zonder kloktijd
        wisselLabelKort: 'tot ' + smFmtDateNl(lockMoment) + ', daarna elke maand tot de ' + lockDay + 'e'
      };
    }
    var r9 = build(9, LOCK_DAY_C1), r25 = build(25, LOCK_DAY_C15);
    var eerst = (r9.lock.getTime() < r25.lock.getTime()) ? r9 : r25;
    var tweede = (eerst === r9) ? r25 : r9;
    return { r9: r9, r25: r25, eerst: eerst, tweede: tweede };
  }
  window.smRoundDates = computeRoundDates;

  var FIRST_SHIP_SHOW_MAX_DAYS = 15; // 15: zo valt de 4e (eerste parfum op maandag de 19e na een weekend) er nog in
  var FIRST_SHIP_GENERIC = 'Je eerste parfum gaat mee met de eerstvolgende verzendronde. De precieze datum zie je direct na je aanmelding.';
  function computeFirstShip() {
    var now = new Date();
    var Y = now.getUTCFullYear(), M = now.getUTCMonth(), D = now.getUTCDate(), H = now.getUTCHours();
    var CUT = 12; // SIGNUP_CUTOFF_HOUR_UTC

    var cycle;
    if (D === LOCK_DAY_C15 && H >= CUT) cycle = 1;
    else if (D > LOCK_DAY_C15 && D < LOCK_DAY_C1) cycle = 1;
    else if (D === LOCK_DAY_C1 && H < CUT) cycle = 1;
    else cycle = 15;

    var shipDate, deadline, recurDay;
    if (cycle === 1) {
      shipDate = new Date(Date.UTC(Y, M + 1, SHIP_DAY_C1));     // verzenddag volgende maand
      deadline = new Date(Date.UTC(Y, M, LOCK_DAY_C1, CUT));   // t/m lockdag 12:00 UTC
      recurDay = SHIP_DAY_C1 + 'e';
    } else {
      var beforeThisMonth6 = (D < LOCK_DAY_C15) || (D === LOCK_DAY_C15 && H < CUT);
      shipDate = new Date(Date.UTC(Y, beforeThisMonth6 ? M : M + 1, SHIP_DAY_C15));
      deadline = new Date(Date.UTC(Y, beforeThisMonth6 ? M : M + 1, LOCK_DAY_C15, CUT));
      recurDay = SHIP_DAY_C15 + 'e';
    }

    var fmtDate = function (d) {
      try { return d.toLocaleDateString('nl-NL', { day: 'numeric', month: 'long', timeZone: 'Europe/Amsterdam' }); }
      catch (e) { return ''; }
    };

    // Deadline MET kloktijd, DST-bestendig: SIGNUP_CUTOFF_HOUR_UTC (12:00 UTC)
    // wordt automatisch 14:00 in de zomer (CEST) en 13:00 in de winter (CET).
    var fmtDateTime = function (d) {
      try {
        return fmtDate(d) + ' om ' + d.toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Amsterdam' });
      } catch (e) { return fmtDate(d); }
    };

    // Eerste zending = lock + 8 dagen; weekend en 1 jan / 25-26 dec schuiven door naar de
    // eerstvolgende werkdag. Kopie van kalender/timing_config.py first_ship_date(). Dit is de
    // ENIGE datum die we beloven ("rond 2 oktober"); de verzenddag zelf (9e/25e) is het vaste
    // ritme daarna.
    var early = smFirstShipFromLock(deadline);

    // Kloktijd altijd erbij (terug sinds 17 sep 2026, zoals de oude tekst "vóór 22 september om 14:00"):
    // het is de exacte aanmeldgrens (12:00 UTC, dus 14:00 zomer / 13:00 winter) en geeft de
    // "nu of pas volgende ronde"-druk. Op de aanmelddag zelf wordt het "vandaag vóór 14:00".
    var isToday = fmtDate(deadline) === fmtDate(now);
    var timeLabel = '';
    try { timeLabel = deadline.toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Amsterdam' }); } catch (e) {}
    var deadlineWithTime = fmtDate(deadline) + (timeLabel ? ' om ' + timeLabel : '');
    var signupHtml = isToday
      ? 'Meld je vandaag vóór <strong>' + timeLabel + '</strong> aan'
      : 'Meld je aan vóór <strong>' + deadlineWithTime + '</strong>';
    var signupQuestionHtml = isToday
      ? 'Meld je je vandaag vóór <strong>' + timeLabel + '</strong> aan?'
      : 'Meld je je aan vóór <strong>' + deadlineWithTime + '</strong>?';
    // Eén concrete datum (besluit 17 sep 2026, was "tussen 2 en 9 oktober"): "rond 2 oktober".
    // rangeLabel blijft bestaan voor oudere aanroepers, maar bevat nu dezelfde enkele datum.
    var firstShipLabel = fmtDate(early);
    var rangeLabel = firstShipLabel;

    // Okt 2026 (besluit Leslie): concrete datum + deadline alleen als het eerste parfum binnen
    // FIRST_SHIP_SHOW_MAX_DAYS komt (dichtbij = reden om nu te beslissen). Verder weg: geen datum
    // (een wachttijd van 3 weken schrikt af); de echte datum staat op de succespagina en in de mail.
    // "Daarna elke maand rond de ..." is voor gasten weggelaten (leden zien hun eigen ritme).
    var daysToFirst = Math.ceil((early.getTime() - now.getTime()) / 86400000);
    var near = daysToFirst <= FIRST_SHIP_SHOW_MAX_DAYS;
    var html = near
      ? '<span class="gk-tip-line">' + signupHtml + ', dan versturen we je eerste parfum al rond <strong>' + firstShipLabel + '</strong>.</span>'
      : '<span class="gk-tip-line">' + FIRST_SHIP_GENERIC + '</span>';
    return { cycle: cycle, html: html, near: near, daysToFirst: daysToFirst, shipLabel: fmtDate(shipDate), earlyLabel: firstShipLabel, firstShipLabel: firstShipLabel, lockLabel: fmtDate(deadline), deadlineLabel: fmtDateTime(deadline), recurDay: recurDay,
             signupHtml: signupHtml, signupQuestionHtml: signupQuestionHtml, rangeLabel: rangeLabel };
  }

  // "Meld je je vandaag aan"-voorbeeld in FAQ's: vult [data-sm-vandaag] met dezelfde
  // berekening als de tooltip. Sommige FAQ's worden pas na load door JS gerenderd,
  // daarom een paar keer opnieuw proberen (15 s).
  window.smFirstShip = computeFirstShip;
  (function () {
    var tries = 0;
    function fill() {
      var els = document.querySelectorAll('[data-sm-vandaag]:not([data-sm-filled])');
      if (els.length) {
        var info = computeFirstShip();
        for (var i = 0; i < els.length; i++) {
          els[i].innerHTML = info.near
            ? info.signupQuestionHtml + ' Dan versturen we je eerste parfum al rond <strong>' + info.firstShipLabel + '</strong>.'
            : FIRST_SHIP_GENERIC;
          els[i].hidden = false;
          els[i].setAttribute('data-sm-filled', '1');
        }
      }
      // Verzendgroep-blokken: "de 24e om 14:00 uur" -> "24 september om 14:00 uur", "de 2e van de maand erna" -> "2 oktober".
      var rEls = document.querySelectorAll('[data-sm-ronde]:not([data-sm-filled])');
      if (rEls.length) {
        var rd = computeRoundDates();
        for (var j = 0; j < rEls.length; j++) {
          var el = rEls[j], r = el.getAttribute('data-sm-ronde'), v = el.getAttribute('data-sm-veld');
          var compact = !!(el.closest && el.closest('[data-sm-compact]'));
          {
            var ri = (r === '9') ? rd.r9 : rd.r25;
            if (v === 'sluit') el.textContent = ri.sluitLabel;
            else if (v === 'sub') {
              // Eerstvolgende groep: "vóór <sluiting>"; de andere: "tussen <sluiting eerste> en <eigen sluiting>".
              // Homepage (data-sm-compact): zonder kloktijd; FAQ-pagina en start-je-geurreis: met kloktijd.
              var eigen = compact ? smFmtDateNl(ri.lock) : ri.sluitKort;
              var eerste = compact ? smFmtDateNl(rd.eerst.lock) : rd.eerst.sluitKort;
              el.textContent = (ri === rd.eerst)
                ? 'Meld je je aan vóór ' + eigen + '? Dan kom je in verzendgroep ' + ri.ronde + '.'
                : 'Meld je je aan tussen ' + eerste + ' en ' + eigen + '? Dan kom je in verzendgroep ' + ri.ronde + '.';
            }
            else if (v === 'eerste') el.textContent = ri.eersteLabel;
            else if (v === 'wissel') el.textContent = compact ? ri.wisselLabelKort : ri.wisselLabel;
            else if (v === 'tag') {
              var isEerst = (ri === rd.eerst);
              el.hidden = !isEerst;
              var kaart = el.closest ? el.closest('.sm-vg') : null;
              if (kaart) kaart.classList.toggle('sm-vg--next', isEerst);
            }
          }
          el.setAttribute('data-sm-filled', '1');
        }
      }
    }
    function tick() { try { fill(); } catch (e) {} if (++tries < 30) setTimeout(tick, 500); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tick); else tick();
  })();

  // Bepaalt of de modal je (voor zover nu bekend) als abonnee ziet. Zelfde
  // definitie als de (i)-tooltip-gate, zodat knop en (i) elkaar exact aanvullen.
  // Echte sessie: status/tags (smIsSubscriber) zijn autoritatief. JWT-recovery
  // (sessie verlopen, JWT geldig): de JWT-cache (sm-sub-early) is de gok, die
  // ensureGkMetaData daarna via /subscription/status bevestigt. Bewust NIET de
  // cycle-metafield (sm-subscriber class): die kan los blijven staan (oud/opgezegd
  // account) en zou de gast-hint dan onterecht verbergen.
  function gkAudienceIsSubscriber() {
    if (window.smJwtRecovered === true) {
      return document.documentElement.classList.contains('sm-sub-early');
    }
    return window.smIsSubscriber === true;
  }

  // Toont/verbergt de "Wanneer komt mijn eerste parfum?"-gasthint, exact
  // complementair aan de (i)-tooltip. Override't de CSS-regel
  // (html.sm-subscriber #gk-first-ship { display:none !important }) met een inline
  // !important, zodat een losstaande cycle-metafield zonder actieve status geen
  // dead-zone geeft (knop én (i) allebei verborgen).
  function gkApplyFirstShipVisibility(isSubscriber) {
    var btn = document.getElementById('gk-first-ship');
    if (!btn) return; // echte abonnee: server-side niet gerenderd → niets te doen
    if (isSubscriber) { btn.style.setProperty('display', 'none', 'important'); return; }

    btn.style.setProperty('display', 'flex', 'important');
    if (btn.dataset.gkBound === '1') return; // tekst + click-handler maar één keer
    btn.dataset.gkBound = '1';
    try {
      var info = computeFirstShip();
      var tip = btn.querySelector('.gk-first-tip');
      if (tip) tip.innerHTML = info.html;
    } catch (e) {}
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      btn.classList.toggle('is-open');
    });
  }

  function fillGuestFirstShip() {
    gkApplyFirstShipVisibility(gkAudienceIsSubscriber());
  }

  /* ======================== RENDER ======================== */

  // 3:4-kaartverhouding afdwingen met expliciete hoogte. CSS heeft al
  // aspect-ratio, maar op de live site kan andere (oudere) CSS dit
  // overschrijven — een inline height wint altijd.
  // BELANGRIJK: eerst hoogtes wissen + reflow, anders leidt aspect-ratio
  // een breedte af uit de oude hoogte en groeien kaarten nooit meer mee
  // met hun gridkolom (smalle kaarten met gaten op iPad/desktop).
  function gkEnforceSlotRatio() {
    const slots = document.querySelectorAll('.geurkalender-grid .geurkalender-slot');
    if (!slots.length) return;
    slots.forEach(s => { s.style.height = ''; s.style.aspectRatio = ''; });
    void document.body.offsetWidth; // reflow: breedte komt weer uit de kolom
    slots.forEach(s => {
      const w = s.offsetWidth;
      if (w > 0) {
        s.style.height = Math.round(w / 0.71) + 'px'; // zelfde verhouding als CSS aspect-ratio
        s.style.aspectRatio = 'auto'; // voorkom breedte-afleiding uit de vaste hoogte
      }
    });
  }
  if (!window._gkRatioBound) {
    window._gkRatioBound = true;
    let _gkRatioTimer;
    const _gkRatioRefresh = () => { clearTimeout(_gkRatioTimer); _gkRatioTimer = setTimeout(() => { gkEnforceSlotRatio(); gkUpdateScrollHint(); }, 120); };
    window.addEventListener('resize', _gkRatioRefresh);
    window.addEventListener('orientationchange', _gkRatioRefresh);
  }

  // Mobiele scroll-fade (CSS staat in geurkalender-desktop.css): verberg de fade
  // zodra het grid volledig gescrold is, of als er niets te scrollen valt.
  function gkUpdateScrollHint() {
    const m = document.getElementById('geurkalender-modal');
    const grid = m && m.querySelector('.geurkalender-grid');
    if (!m || !grid) return;
    const atEnd = (grid.scrollHeight - grid.scrollTop - grid.clientHeight) <= 4;
    m.classList.toggle('gk-at-end', atEnd);
  }
  function bindGkScrollHint() {
    const grid = document.querySelector('#geurkalender-modal .geurkalender-grid');
    if (grid && grid.dataset.gkScrollBound !== '1') {
      grid.dataset.gkScrollBound = '1';
      grid.addEventListener('scroll', gkUpdateScrollHint, { passive: true });
    }
    // Hoogte kan na (async) render nog wijzigen, dus een paar keer herchecken.
    gkUpdateScrollHint();
    setTimeout(gkUpdateScrollHint, 150);
    setTimeout(gkUpdateScrollHint, 600);
  }

  function renderKalender() {
    const grid = document.querySelector('.geurkalender-grid');
    if (!grid) return;

    normalizeLeftPack();
    grid.innerHTML = '';

    // 🔥 CRITICAL FIX: Gebruik server labels ALLEEN voor subscribers
    const monthLabels = (IS_SUBSCRIBER && window.gkServerLabels) 
      ? window.gkServerLabels 
      : getNext12Months();

    calLog('[Geurkalender] Render:', {
      IS_SUBSCRIBER,
      hasServerLabels: !!window.gkServerLabels,
      usingServerLabels: IS_SUBSCRIBER && !!window.gkServerLabels,
      firstLabel: monthLabels[0]
    });

    for (let i = 0; i < 12; i++) {
      const slot = document.createElement('div');
      slot.className = 'geurkalender-slot';
      slot.dataset.index = String(i);
      // Weergave als "jul 26" (CSS maakt er JUL 26 van) — interne labels blijven "jul 2026"
      const displayMonth = String(monthLabels[i] || '').replace(/\b20(\d{2})\b/, '$1');
      const monthLabel = `<span class="slot-month">${displayMonth}</span>`;

      if (geurkalender[i]) {
        slot.classList.add('filled');
        const p = geurkalender[i];
        const safeTitle = (p.title || '').replace(/"/g, '&quot;');
        // Add variant-id for surcharge badge support
        if (p.variantId) {
          slot.setAttribute('data-variant-id', p.variantId);
        }
        slot.innerHTML = `
          ${monthLabel}
          <button class="slot-remove" data-index="${i}" title="Verwijder">−</button>
          <a href="${p.url}" class="slot-product-link" draggable="false">
            <div class="slot-product" draggable="false">
              <div class="slot-image"><img src="${p.img}" alt="${safeTitle}" draggable="false"></div>
              <div class="slot-info">
                <span class="slot-title">${safeTitle}</span>
                <span class="slot-brand">${p.brand || ''}</span>
              </div>
            </div>
          </a>`;
        // Verouderde productfoto? Haal de huidige live op zodra de opgeslagen URL faalt.
        var slotImg = slot.querySelector('.slot-image img');
        if (slotImg) {
          slotImg.dataset.purl = p.url || '';
          slotImg.onerror = function(){ window.smRefreshProductImg(this, this.dataset.purl); };
          window.smRefreshProductImg(slotImg, p.url, { proactive: true });
        }
      } else {
        slot.innerHTML = `
          ${monthLabel}
          <div class="slot-inner slot-go-products" title="Kies een parfum">+</div>`;
      }
      grid.appendChild(slot);
    }

    // Teller "x/12 geuren" helemaal rechts in de toolbar-rij
    const gkFilledCount = geurkalender.filter(Boolean).length;
    const gkToolbar = document.querySelector('.geurkalender-toolbar');
    if (gkToolbar) {
      let gkCounter = gkToolbar.querySelector('.gk-count');
      if (!gkCounter) {
        // Oude teller-plaatsingen (subtitel of losse rij) opruimen
        document.querySelectorAll('.geurkalender-subtitle .gk-count, .geurkalender-content > .gk-count')
          .forEach(el => el.remove());
        gkCounter = document.createElement('div');
        gkCounter.className = 'gk-count';
        gkToolbar.appendChild(gkCounter);
      }
      gkCounter.textContent = `${gkFilledCount}/12 geuren`;
    }

    // Kaarthoogtes vastzetten op 3:4 (direct + nogmaals na layout-pass)
    gkEnforceSlotRatio();
    requestAnimationFrame(gkEnforceSlotRatio);

    enableDragAndDrop();

    // Apply surcharge badges to geurkalender slots
    if (window.SmellishSurcharges && typeof window.SmellishSurcharges.load === 'function') {
      window.SmellishSurcharges.load().then(surcharges => {
        if (surcharges && Object.keys(surcharges).length > 0) {
          window.SmellishSurcharges.apply(surcharges);
        }
      });
    }

    // "Nieuw" badges bewust NIET in geurkalender - te rommelig in kleine slots
    // Surcharge badge is voldoende; "nieuw" info is irrelevant voor gekozen geuren

    renderGkInfo(); // verzend- + wijzig-info achter de (i) (alleen abonnees)
  }

  function addToKalender(title,img,brand,url,variantId){
    // 🎁 Block surcharge products for gift subscriptions
    if (isVariantBlocked(variantId)) {
      showBlockedProductMessage(title);
      return false;
    }

    dirty = true;
    normalizeLeftPack();
    for (let i=0;i<12;i++){
      if (!geurkalender[i]) {
        geurkalender[i] = sanitizeItem({title,img,brand,url,variantId});
        break;
      }
    }
    ignoreExternalUntil = Date.now() + 1200;
    saveKalender(true);

    if (SERVER_OK && !inflight) {
      clearTimeout(persistTimer);
      pushServerNow();
    }

    renderKalender();
    return true;
  }

  // Checkout-geurkiezer (okt 2026): geur toevoegen zonder de kalender-modal te openen
  // Zet een geur op maand 1 (slot 0), ook als daar al een geur stond (wisselen).
  window.smSetFirstKalender = function(title,img,brand,url,variantId){
    if (isVariantBlocked(variantId)) { showBlockedProductMessage(title); return false; }
    dirty = true;
    geurkalender[0] = sanitizeItem({title,img,brand,url,variantId});
    ignoreExternalUntil = Date.now() + 1200;
    saveKalender(true);
    if (SERVER_OK && !inflight) { clearTimeout(persistTimer); pushServerNow(); }
    renderKalender();
    return true;
  };

  // 🎁 Show message when blocked product is attempted
  function showBlockedProductMessage(productTitle) {
    // Remove any existing message
    const existing = document.querySelector('.gk-blocked-message');
    if (existing) existing.remove();

    const msg = document.createElement('div');
    msg.className = 'gk-blocked-message';
    msg.innerHTML = `
      <div class="gk-blocked-content">
        <span class="gk-blocked-icon">🎁</span>
        <p><strong>${productTitle || 'Dit parfum'}</strong> is een premium geur met toeslag.</p>
        <p>Deze is niet beschikbaar bij je cadeau-abonnement. Kies een andere geur!</p>
        <button class="gk-blocked-close">Begrepen</button>
      </div>
    `;

    // Style the message
    msg.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0,0.7);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 100001;
      animation: fadeIn 0.2s ease;
    `;

    const content = msg.querySelector('.gk-blocked-content');
    content.style.cssText = `
      background: #fff;
      padding: 24px 32px;
      border-radius: 12px;
      text-align: center;
      max-width: 320px;
      box-shadow: 0 8px 32px rgba(0,0,0,0.3);
    `;

    const icon = msg.querySelector('.gk-blocked-icon');
    icon.style.cssText = `
      font-size: 40px;
      display: block;
      margin-bottom: 12px;
    `;

    const btn = msg.querySelector('.gk-blocked-close');
    btn.style.cssText = `
      background: #000;
      color: #fff;
      border: none;
      padding: 10px 24px;
      border-radius: 6px;
      cursor: pointer;
      margin-top: 16px;
      font-weight: 600;
    `;

    btn.addEventListener('click', () => msg.remove());
    msg.addEventListener('click', (e) => {
      if (e.target === msg) msg.remove();
    });

    document.body.appendChild(msg);
  }
  
  function removeFromKalender(index){
    dirty = true;
    geurkalender.splice(index,1);
    while (geurkalender.length<12) geurkalender.push(null);
    ignoreExternalUntil = Date.now() + 1200;
    saveKalender(true);

    if (SERVER_OK && !inflight) {
      clearTimeout(persistTimer);
      pushServerNow();
    }

    renderKalender();
  }

  async function autoFillKalender() {
    const emptyCount = geurkalender.filter(s => !s).length;
    if (emptyCount === 0) return;

    const btn = document.getElementById('gk-autofill-btn');
    const resetBtn = (label) => {
      if (!btn) return;
      btn.disabled = false;
      btn.textContent = label || 'Auto-vullen';
    };

    if (btn) { btn.disabled = true; btn.textContent = 'Bezig...'; }

    try {
      const gender = window.smellishGender || null;
      // Collect variant IDs already in the calendar to prevent duplicates
      const existingVariantIds = geurkalender
        .filter(Boolean)
        .map(p => p.variantId)
        .filter(Boolean);

      // Compute month numbers (1-12) for each empty slot for per-slot season matching
      const monthLabelsForFill = (IS_SUBSCRIBER && window.gkServerLabels)
        ? window.gkServerLabels
        : getNext12Months();
      const monthAbbrevToNum = {jan:1,feb:2,mrt:3,apr:4,mei:5,jun:6,jul:7,aug:8,sep:9,okt:10,nov:11,dec:12};
      const emptySlotMonths = [];
      for (let i = 0; i < 12; i++) {
        if (!geurkalender[i] && monthLabelsForFill[i]) {
          const parts = monthLabelsForFill[i].split(' ');
          // Label is "mrt 2026" or "15 mrt 2026"
          const monthStr = parts.length === 3 ? parts[1] : parts[0];
          const monthNum = monthAbbrevToNum[monthStr.toLowerCase()] || null;
          if (monthNum) emptySlotMonths.push(monthNum);
        }
      }

      let url = `${API_BASE}/calendar/auto-fill?needed=${emptyCount}`;
      if (CUSTOMER_ID) url += `&customer_id=${CUSTOMER_ID}`;
      if (gender) url += `&gender=${encodeURIComponent(gender)}`;
      if (existingVariantIds.length > 0) url += `&exclude=${existingVariantIds.join(',')}`;
      if (emptySlotMonths.length > 0) url += `&slot_months=${emptySlotMonths.join(',')}`;

      const headers = await getAuthHeaders();
      const res = await fetch(url, { headers });
      if (!res.ok) throw new Error(`auto-fill request failed: ${res.status}`);
      const data = await res.json();

      const productQueue = (data.products || []).slice();

      // No products returned (e.g. empty stock) → show brief message, do nothing
      if (productQueue.length === 0) {
        resetBtn('Geen geuren beschikbaar');
        setTimeout(() => resetBtn('Auto-vullen'), 2500);
        return;
      }

      for (let i = 0; i < 12; i++) {
        if (!geurkalender[i] && productQueue.length > 0) {
          geurkalender[i] = sanitizeItem(productQueue.shift());
        }
      }

      dirty = true;
      ignoreExternalUntil = Date.now() + 1200;
      saveKalender(true);
      if (SERVER_OK && !inflight) {
        clearTimeout(persistTimer);
        pushServerNow();
      }
      renderKalender();
      resetBtn('Auto-vullen');
    } catch (err) {
      calError('[AUTO-FILL] Error:', err);
      resetBtn('Probeer opnieuw');
      setTimeout(() => resetBtn('Auto-vullen'), 2500);
    }
  }

  function clearAllKalender() {
    const filled = geurkalender.filter(Boolean).length;
    if (filled === 0) return;
    if (!confirm(`Weet je zeker dat je alle ${filled} geuren wilt verwijderen?`)) return;

    geurkalender = Array(12).fill(null);
    dirty = true;
    ignoreExternalUntil = Date.now() + 1200;
    saveKalender(true);
    if (SERVER_OK && !inflight) {
      clearTimeout(persistTimer);
      pushServerNow();
    }
    renderKalender();
  }
  
  function openModalWithProduct(title,img,brand,url,variantId){
  addToKalender(title,img,brand,url,variantId);
  
  // 🆕 SIMPLIFIED - Track calendar add (check happens inside function)
  trackCalendarAdd(title, variantId);
  
  showModalOnly();
}

// 🆕 NEW FUNCTION - Add after openModalWithProduct
// 🆕 IMPROVED VERSION
async function trackCalendarAdd(productTitle, variantId) {
  try {
    // Check if from quiz (with 30 min expiry)
    const quizActive = localStorage.getItem('quiz_active');
    const quizTimestamp = localStorage.getItem('quiz_timestamp');
    
    if (!quizActive || quizActive !== 'true') {
      calLog('[CALENDAR] Not from quiz - skipping tracking');
      return;
    }
    
    // Check expiry (30 minutes)
    if (quizTimestamp) {
      const age = Date.now() - parseInt(quizTimestamp);
      const MAX_AGE = 30 * 60 * 1000; // 30 min
      
      if (age > MAX_AGE) {
        calLog('[CALENDAR] Quiz session expired - skipping tracking');
        localStorage.removeItem('quiz_active');
        localStorage.removeItem('quiz_timestamp');
        return;
      }
    }
    
    const sessionId = localStorage.getItem('quiz_session_id');
    
    if (!sessionId) {
      calWarn('[CALENDAR] No quiz session ID found!');
      return;
    }
    
    calLog('[CALENDAR] 🎯 Tracking quiz calendar add:', {
      productTitle,
      sessionId,
      customerId: CUSTOMER_ID
    });
    
    const response = await fetch(`${API_BASE}/quiz/track-calendar-add`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        session_id: sessionId,
        customer_id: CUSTOMER_ID,
        product_title: productTitle,
        product_variant_id: variantId
      })
    });
    
    const result = await response.json();
    calLog('[CALENDAR] Tracking result:', result);
    
    // Clear flag after successful track
    if (result.ok) {
      localStorage.removeItem('quiz_active');
      localStorage.removeItem('quiz_timestamp');
    }
    
  } catch (error) {
    calError('[CALENDAR] Tracking failed:', error);
  }
}

// Helper: Get quiz session ID from localStorage
function getQuizSessionId() {
  try {
    return localStorage.getItem('quiz_session_id');
  } catch(_) {
    return null;
  }
}

  /* ==================== DRAG & DROP (UNCHANGED) ==================== */
  let suppressClickUntil = 0;

  function enableDragAndDrop() {
    const grid = document.querySelector('.geurkalender-grid');
    if (!grid) return;

    grid.querySelectorAll('.geurkalender-slot').forEach(s => s.classList.remove('drag-over','dragging'));
    grid.querySelectorAll('.geurkalender-slot.filled a, .geurkalender-slot.filled img, .geurkalender-slot.filled .slot-product')
      .forEach(el => el.setAttribute('draggable','false'));

    const ANIM_MS = 420;
    const EASING  = 'cubic-bezier(0.2, 0.8, 0.2, 1)';

    function getSlotUnder(x, y) { const el = document.elementFromPoint(x, y); return el && el.closest('.geurkalender-slot'); }
    function swap(fromIndex, toIndex) { const t = geurkalender[fromIndex]; geurkalender[fromIndex] = geurkalender[toIndex]; geurkalender[toIndex] = t; }
    
    function FLIPAnimateSwap(fromIndex, toIndex, onDone){
      const fromEl = grid.querySelector(`.geurkalender-slot[data-index="${fromIndex}"]`);
      const toEl   = grid.querySelector(`.geurkalender-slot[data-index="${toIndex}"]`);
      if (!fromEl || !toEl) { onDone?.(); return; }
      const fromRect = fromEl.getBoundingClientRect();
      const toRect   = toEl.getBoundingClientRect();
      const dx = toRect.left - fromRect.left;
      const dy = toRect.top  - fromRect.top;
      fromEl.style.willChange = 'transform, opacity';
      toEl.style.willChange   = 'transform, opacity';
      fromEl.style.transition = toEl.style.transition = `transform ${ANIM_MS}ms ${EASING}, opacity ${ANIM_MS}ms ${EASING}`;
      fromEl.offsetHeight;
      fromEl.style.transform = `translate(${dx}px, ${dy}px)`;
      toEl.style.transform   = `translate(${-dx}px, ${-dy}px)`;
      fromEl.style.opacity = '0.94'; toEl.style.opacity = '0.94';
      setTimeout(() => {
        fromEl.style.transition = toEl.style.transition = '';
        fromEl.style.transform = toEl.style.transform = '';
        fromEl.style.opacity = toEl.style.opacity = '';
        fromEl.style.willChange = toEl.style.willChange = '';
        onDone?.();
      }, ANIM_MS + 12);
    }

    let isDragging = false, animating = false, dropPending = false;
    let dragEl = null, fromIndex = null, currentOver = null, ghost = null;
    let startX = 0, startY = 0, hasMoved = false, pressTimer = null;

    function createGhost(fromSlot, x, y){
      const rect = fromSlot.getBoundingClientRect();
      const g = fromSlot.cloneNode(true);
      g.classList.add('gk-touch-ghost');
      g.style.position = 'fixed';
      g.style.left = (x - rect.width/2) + 'px';
      g.style.top  = (y - rect.height/2) + 'px';
      g.style.width = rect.width + 'px';
      g.style.height = rect.height + 'px';
      g.style.pointerEvents = 'none';
      g.style.zIndex = '100000';
      g.style.opacity = '0.98';
      g.style.transform = 'scale(0.985)';
      g.style.boxShadow = '0 12px 24px rgba(0,0,0,0.25)';
      document.body.appendChild(g);
      return g;
    }
    
    function moveGhost(g, x, y){
      const r = g.getBoundingClientRect();
      g.style.left = (x - r.width/2) + 'px';
      g.style.top  = (y - r.height/2) + 'px';
    }
    
    function cleanup() {
      if (ghost && ghost.parentNode) ghost.parentNode.removeChild(ghost);
      ghost = null;
      if (dragEl) {
        dragEl.classList.remove('dragging');
        dragEl.querySelectorAll('a, img, .slot-remove').forEach(el => el.style.pointerEvents = '');
      }
      if (currentOver) currentOver.classList.remove('drag-over');
      isDragging = false; hasMoved = false; animating = false; dropPending = false;
      dragEl = null; currentOver = null; fromIndex = null;
      document.removeEventListener('mousemove', preDragMove);
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    }

    let pendingTarget = null;
    function requestAutoSwap(toIdx){
      // Er kan nog een wissel in de wachtrij staan (de setTimeout onderaan deze functie)
      // terwijl de sleep al is afgelopen. cleanup() heeft fromIndex dan op null gezet, en
      // swap(null, x) schrijft undefined over de geur in het DOELvakje. normalizeLeftPack
      // filtert die er vervolgens uit en pushServerNow schrijft het verlies meteen naar de
      // database. Dus alleen wisselen zolang er echt een geur onder de vinger zit.
      if (!Number.isInteger(fromIndex) || !geurkalender[fromIndex]) return;

      const limit = firstEmptyIndex(geurkalender);
      const clamped = Math.min(toIdx, limit);
      if (clamped === fromIndex) return;

      suppressClickUntil = Date.now() + 500;

      if (animating) { pendingTarget = clamped; return; }
      animating = true;

      // De wissel gebeurt pas ~432 ms later, in de callback hieronder. fromIndex is
      // een gedeelde variabele die in die tijd kan veranderen: renderKalender() bouwt bij
      // elke wissel de sleepmachine opnieuw op (r1663) en cleanup() zet fromIndex op null.
      // Daarom hier VASTLEGGEN, en in de callback opnieuw toetsen aan de levende lijst.
      // swap() met een ongeldige bron schrijft undefined over de geur in het doelvakje,
      // die valt daarna weg in normalizeLeftPack en wordt meteen naar de database gestuurd.
      const vanIndex = fromIndex;
      const naarIndex = clamped;

      FLIPAnimateSwap(vanIndex, naarIndex, () => {
        if (!Number.isInteger(vanIndex) || !geurkalender[vanIndex]) {
          // Sleep is onderweg ongeldig geworden: niets muteren, wel netjes afronden
          // zodat de sleepmachine niet blijft hangen op animating = true.
          const alsnog = pendingTarget; pendingTarget = null; animating = false;
          if (alsnog != null && !dropPending) setTimeout(() => requestAutoSwap(alsnog), 0);
          if (dropPending) setTimeout(cleanup, 0);
          return;
        }
        dirty = true;
        swap(vanIndex, naarIndex);
        ignoreExternalUntil = Date.now() + 1200;
        saveKalender(true);
        
        if (SERVER_OK && !inflight) {
          clearTimeout(persistTimer);
          pushServerNow();
        }
        
        renderKalender();

        const newGrid = document.querySelector('.geurkalender-grid');
        const newDragEl = newGrid && newGrid.querySelector(`.geurkalender-slot.filled[data-index="${naarIndex}"]`);
        if (newDragEl && !dropPending) {
          dragEl = newDragEl; fromIndex = naarIndex; isDragging = true;
          dragEl.querySelectorAll('a, img, .slot-remove').forEach(el => el.style.pointerEvents = 'none');
        }

        const next = pendingTarget; pendingTarget = null; animating = false;
        if (next != null && !dropPending) setTimeout(() => requestAutoSwap(next), 0);
        if (dropPending) setTimeout(cleanup, 0);
      });
    }

    const THRESH = 2;
    function preDragMove(e){
      const dx = Math.abs(e.clientX - startX);
      const dy = Math.abs(e.clientY - startY);
      if (dx > THRESH || dy > THRESH) {
        isDragging = true;
        dragEl.classList.add('dragging');
        dragEl.querySelectorAll('a, img, .slot-remove').forEach(el => el.style.pointerEvents = 'none');
        ghost = createGhost(dragEl, startX, startY);
        document.removeEventListener('mousemove', preDragMove);
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
      }
    }
    
    function onMouseMove(e){
      if (!isDragging) return;
      hasMoved = true;
      moveGhost(ghost, e.clientX, e.clientY);
      const over = getSlotUnder(e.clientX, e.clientY);
      if (over && over.parentElement === grid) {
        if (currentOver && currentOver !== over) currentOver.classList.remove('drag-over');
        currentOver = over; currentOver.classList.add('drag-over');
        const toIdx = parseInt(over.dataset.index, 10);
        if (!Number.isNaN(toIdx)) requestAutoSwap(toIdx);
      } else {
        if (currentOver) { currentOver.classList.remove('drag-over'); currentOver = null; }
      }
      e.preventDefault();
    }
    
    function onMouseUp(){
      if (isDragging) suppressClickUntil = Date.now() + 450;
      if (animating) { dropPending = true; } else { cleanup(); }
    }

    grid.querySelectorAll('.geurkalender-slot.filled').forEach(slot => {
      slot.addEventListener('mousedown', function(e){
        if (e.button !== 0) return;
        if (e.target.closest('.slot-remove')) return;
        dragEl = slot; fromIndex = parseInt(slot.dataset.index, 10);
        startX = e.clientX; startY = e.clientY; hasMoved = false;
        document.addEventListener('mousemove', preDragMove);
        document.addEventListener('mouseup', onMouseUp);
      });
    });

    grid.querySelectorAll('.geurkalender-slot.filled').forEach(slot => {
      slot.addEventListener('touchstart', function(e){
        if (e.target.closest('.slot-remove')) return;
        const t = e.touches[0]; startX = t.clientX; startY = t.clientY;
        pressTimer = setTimeout(() => {
          dragEl = slot; fromIndex = parseInt(slot.dataset.index, 10);
          isDragging = true; dragEl.classList.add('dragging');
          dragEl.querySelectorAll('a, img, .slot-remove').forEach(el => el.style.pointerEvents = 'none');
          ghost = createGhost(slot, startX, startY);
          if (navigator.vibrate) { try { navigator.vibrate(50); } catch(_){} }
        }, 500);
      }, { passive: true });

      slot.addEventListener('touchmove', function(e){
        const t = e.touches[0];
        const dx = Math.abs(t.clientX - startX);
        const dy = Math.abs(t.clientY - startY);
        if (!isDragging && (dx > 8 || dy > 8)) { clearTimeout(pressTimer); return; }
        if (!isDragging) return;
        hasMoved = true; moveGhost(ghost, t.clientX, t.clientY);
        const over = getSlotUnder(t.clientX, t.clientY);
        if (over && over.parentElement === grid) {
          if (currentOver && currentOver !== over) currentOver.classList.remove('drag-over');
          currentOver = over; currentOver.classList.add('drag-over');
          const toIdx = parseInt(over.dataset.index, 10);
          if (!Number.isNaN(toIdx)) requestAutoSwap(toIdx);
        } else {
          if (currentOver) { currentOver.classList.remove('drag-over'); currentOver = null; }
        }
        e.preventDefault();
      }, { passive: false });

      slot.addEventListener('touchend', function(){
        clearTimeout(pressTimer);
        if (isDragging) suppressClickUntil = Date.now() + 500;
        if (animating) { dropPending = true; } else { cleanup(); }
      }, { passive: true });

      slot.addEventListener('touchcancel', function(){
        clearTimeout(pressTimer);
        // Zelfde afhandeling als touchend: loopt er nog een animatie, dan pas opruimen
        // zodra die klaar is. Anders verdwijnt fromIndex terwijl er nog een wissel
        // onderweg is. cleanup() zet dropPending zelf weer op false.
        if (animating) { dropPending = true; } else { cleanup(); }
      }, { passive: true });
    });
  }

  document.addEventListener('click', function(ev){
    if (Date.now() < suppressClickUntil) {
      if (ev.target.closest('.geurkalender-slot')) { ev.preventDefault(); ev.stopPropagation(); }
    }
  }, true);

  /* ======================== EVENT LISTENERS ======================== */
  closeBtn && closeBtn.addEventListener('click', (e)=>{ e.preventDefault(); closeModal(); });

  document.addEventListener('click', function (e) {
    if (!isModalOpen()) return;
    if (Date.now() < gkIgnoreDocClickUntil) return;
    const clickInsideModal = modal.contains(e.target);
    const clickOnPlusBtn   = e.target.closest('.fav-add-to-calendar, .add-to-calendar');
    const clickOnRemoveBtn = e.target.closest('.slot-remove');
    const clickOnCloseBtn  = e.target.closest('#close-geurkalender');
    if (!clickInsideModal && !clickOnPlusBtn && !clickOnRemoveBtn && !clickOnCloseBtn) closeModal();
  });

  document.body.addEventListener('click', e => {
    const btn = e.target.closest('.fav-add-to-calendar');
    if (btn) {
      if (Date.now() < gkAddDedupUntil) { e.preventDefault(); e.stopPropagation(); return; }
      gkAddDedupUntil = Date.now() + 1200; // ✅ Langer voor animatie
      e.preventDefault(); e.stopPropagation();

      // ✅ Animatie: spin + pulse
      btn.classList.add('adding');

      setTimeout(() => {
        // ✅ Na spin: toon vinkje
        btn.classList.remove('adding');
        btn.classList.add('added');

        setTimeout(() => {
          // ✅ Open geurkalender
          openModalWithProduct(btn.dataset.title, btn.dataset.img, btn.dataset.brand || '', btn.dataset.url || '#', btn.dataset.variantId || undefined);

          // ✅ Reset button na 1.5 seconde
          setTimeout(() => {
            btn.classList.remove('added');
          }, 1500);
        }, 300);
      }, 500);
    }
  });

  document.body.addEventListener('click', e => {
    const removeBtn = e.target.closest('.slot-remove');
    if (removeBtn) {
      e.preventDefault();
      const slot = removeBtn.closest('.geurkalender-slot');
      const index = parseInt(removeBtn.dataset.index, 10);

      // ✅ Animatie: slot krimpt en fade out
      if (slot) {
        slot.classList.add('removing');
        setTimeout(() => {
          removeFromKalender(index);
        }, 300);
      } else {
        removeFromKalender(index);
      }
      return;
    }
    const goBtn = e.target.closest('.slot-go-products');
    if (goBtn) window.location.href = 'https://smellish.nl/collections/products?';
    if (e.target.closest('#gk-autofill-btn')) { e.preventDefault(); autoFillKalender(); }
    if (e.target.closest('#gk-clearall-btn')) { e.preventDefault(); clearAllKalender(); }
    const infoIcon = e.target.closest('#gk-info-icon');
    if (infoIcon) {
      e.preventDefault();
      const wrap = infoIcon.closest('.gk-info-wrap');
      if (wrap) {
        const isOpen = wrap.classList.contains('tooltip-open');
        // Close any other open tooltips
        document.querySelectorAll('.gk-info-wrap.tooltip-open').forEach(w => w.classList.remove('tooltip-open'));
        if (!isOpen) wrap.classList.add('tooltip-open');
      }
      return;
    }
    // Elke andere klik sluit de tooltip — óók op de tooltip-tekst zelf of op Auto-vullen.
    // We blokkeren de klik NIET, zodat Auto-vullen gewoon werkt terwijl de tooltip dichtgaat.
    document.querySelectorAll('.gk-info-wrap.tooltip-open').forEach(w => w.classList.remove('tooltip-open'));
  });

  document.body.addEventListener('click', e => {
    const btn = e.target.closest('.geurkalender-knop');
    if (btn) {
      if (Date.now() < gkAddDedupUntil) { e.preventDefault(); e.stopPropagation(); return; }
      gkAddDedupUntil = Date.now() + 1200;
      e.preventDefault(); e.stopPropagation();

      btn.classList.add('adding');

      setTimeout(() => {
        btn.classList.remove('adding');
        btn.classList.add('added');

        setTimeout(() => {
          openModalWithProduct(btn.dataset.title, btn.dataset.img, btn.dataset.brand || '', btn.dataset.url || '#', btn.dataset.variantId || undefined);

          setTimeout(() => {
            btn.classList.remove('added');
          }, 1500);
        }, 300);
      }, 500);
    }
  });

  document.addEventListener('click', function(e){
    const openIcon = e.target.closest('.open-geurkalender-icon');
    if (openIcon) { e.preventDefault(); showModalOnly(); }
  });

  function handleAccountOpen(evt){
    const link = evt.target.closest('.open-geurkalender-account');
    if (!link) return;
    evt.preventDefault(); evt.stopPropagation();
    if (evt.stopImmediatePropagation) evt.stopImmediatePropagation();
    showModalOnly();
  }
  document.addEventListener('click', handleAccountOpen, true);
  document.addEventListener('keydown', function(e){
    if ((e.key === 'Enter' || e.key === ' ') && e.target.closest('.open-geurkalender-account')) { e.preventDefault(); handleAccountOpen(e); }
  }, true);

  (function(){
    function scrapeRecoCardData(btn){
      const card = btn.closest('.product-card');
      const linkEl = card && card.querySelector('a[href]');
      const imgEl  = card && card.querySelector('.product-image img');
      const titleEl= card && card.querySelector('.product-title');
      const brandEl= card && card.querySelector('.product-vendor');
      const title = (btn.dataset.title) || (titleEl && titleEl.textContent.trim()) || (imgEl && imgEl.alt && imgEl.alt.trim()) || 'Product';
      const img   = (btn.dataset.img)   || (imgEl && (imgEl.currentSrc || imgEl.src)) || '';
      const brand = (btn.dataset.brand) || (brandEl && brandEl.textContent.trim()) || '';
      const url   = (btn.dataset.url)   || (linkEl && linkEl.href) || '#';
      const variantId = btn.dataset.variantId || undefined;
      return { title, img, brand, url, variantId };
    }
    function handleRecoClick(evt){
      const btn = evt.target.closest('.add-to-calendar');
      if (!btn) return;
      if (Date.now() < gkAddDedupUntil) { evt.preventDefault(); evt.stopPropagation(); return; }
      gkAddDedupUntil = Date.now() + 1200; // ✅ Langer voor animatie
      evt.preventDefault(); evt.stopPropagation();
      if (evt.stopImmediatePropagation) evt.stopImmediatePropagation();
      const { title, img, brand, url, variantId } = scrapeRecoCardData(btn);

      // ✅ Animatie: spin + pulse
      btn.classList.add('adding');

      setTimeout(() => {
        btn.classList.remove('adding');
        btn.classList.add('added');

        setTimeout(() => {
          openModalWithProduct(title, img, brand, url, variantId);

          setTimeout(() => {
            btn.classList.remove('added');
          }, 1500);
        }, 300);
      }, 500);
    }
    document.addEventListener('click', handleRecoClick, true);
  })();

  (function(){
    const onAccountFavoritesPage =
      location.pathname.indexOf('/pages/accountoverzicht') !== -1 ||
      !!document.querySelector('.account-favorites-section');
    if (!onAccountFavoritesPage) return;

    function scrapeFavCardData(btn){
      const card = btn.closest('.fav-product-card') || btn.closest('.fav-product') || btn.parentElement;
      let linkEl = (card && (card.querySelector('a.fav-product-card__link') || card.querySelector('a.fav-product-card_link'))) ||
                   btn.closest('a.fav-product-card__link, a.fav-product-card_link');
      const imgEl   = (card && card.querySelector('img')) || (linkEl && linkEl.querySelector('img'));
      const titleEl = (card && card.querySelector('.fav-product-title, .product-title, .card-title, [data-title]'));
      const brandEl = (card && card.querySelector('.fav-product-vendor, .fav-product-brand, .product-brand, .card-brand, [data-brand]'));
      const title = btn.dataset.title || (titleEl && titleEl.textContent.trim()) || (imgEl && imgEl.alt && imgEl.alt.trim()) || 'Product';
      const img   = btn.dataset.img   || (imgEl && (imgEl.currentSrc || imgEl.src)) || '';
      const brand = btn.dataset.brand || (brandEl && brandEl.textContent.trim()) || '';
      const url   = btn.dataset.url   || (linkEl && linkEl.href) || '#';
      const variantId = btn.dataset.variantId || undefined;
      return { title, img, brand, url, variantId };
    }

    function handleAccountFavToCalendar(evt){
      const btn = evt.target.closest('.fav-add-to-calendar');
      if (!btn) return;
      if (Date.now() < gkAddDedupUntil) { evt.preventDefault(); evt.stopPropagation(); return; }
      gkAddDedupUntil = Date.now() + 1200; // ✅ Langer voor animatie
      evt.preventDefault(); evt.stopPropagation();
      if (evt.stopImmediatePropagation) evt.stopImmediatePropagation();
      const { title, img, brand, url, variantId } = scrapeFavCardData(btn);

      // ✅ Animatie: spin + pulse
      btn.classList.add('adding');

      setTimeout(() => {
        btn.classList.remove('adding');
        btn.classList.add('added');

        setTimeout(() => {
          openModalWithProduct(title, img, brand, url, variantId);

          setTimeout(() => {
            btn.classList.remove('added');
          }, 1500);
        }, 300);
      }, 500);
    }

    document.addEventListener('click', handleAccountFavToCalendar, true);
  })();

  document.addEventListener('click', function(ev){
    if (Date.now() < suppressClickUntil) {
      if (ev.target.closest('.geurkalender-slot')) { ev.preventDefault(); ev.stopPropagation(); }
    }
  }, true);

  function showDragHintIfNeeded() {
    try {
      if (localStorage.getItem(HINT_KEY) === '1') return;
      const header = modal.querySelector('.geurkalender-header') || modal;
      const hint = document.createElement('div');
      hint.className = 'gk-drag-hint';
      hint.innerHTML = 'Tip: houd een kaartje ingedrukt en <strong>sleep</strong> om te wisselen.';
      header.appendChild(hint);
      requestAnimationFrame(()=>{ hint.classList.add('show'); });
      setTimeout(()=>{ hint.classList.remove('show'); setTimeout(()=>hint.remove(), 400); }, 3500);
      localStorage.setItem(HINT_KEY, '1');
    } catch(_) {}
  }

  document.addEventListener('gk:months-updated', function(e){
    try{
      if (Date.now() < ignoreExternalUntil) return;
      if (inflight || dirty) return;

      const detail = e.detail;
      const months = Array.isArray(detail) ? detail : (detail && detail.months);
      const evtISO = (detail && detail.updatedAt) || null;
      const evtMS  = tsNum(evtISO);
      if (!months || !evtMS) return;

      if (evtMS > lastServerUpdatedAtMS) {
        geurkalender = months.slice(0, 12).map(sanitizeItem);
        lastServerUpdatedAtISO = evtISO; lastServerUpdatedAtMS = evtMS; writeUpdated(lastServerUpdatedAtISO, lastServerUpdatedAtMS);
        saveKalender(false); renderKalender();
      }
    }catch(_){}
  });

  window.addEventListener('visibilitychange', function(){ 
    if (document.visibilityState === 'visible') {
      // 🔥 CHECK: Moet cache gerefresht worden?
      if (IS_SUBSCRIBER && checkIfShouldRefreshLabels()) {
        calLog('[VISIBILITY] Clearing cache - lock window detected');
        clearCachedLabels();
        labelsPreloaded = false;
      }
      refreshFromServer(); 
    }
  });
  
  window.addEventListener('focus', function(){ 
    if (IS_SUBSCRIBER && checkIfShouldRefreshLabels()) {
      calLog('[FOCUS] Clearing cache - lock window detected');
      clearCachedLabels();
      labelsPreloaded = false;
    }
    refreshFromServer(); 
  });
  
  window.addEventListener('beforeunload', function(e) {
    if (dirty && SERVER_OK && !inflight) {
      try {
        const snapshot = (geurkalender || []).slice(0,12).map(sanitizeItem);
        const currentVersion = parseInt(localStorage.getItem(`gk_version_${CUSTOMER_ID}`) || '0');
        const payload = JSON.stringify({
          customer_id: CUSTOMER_ID,
          months: snapshot,
          clientUpdatedAt: lastServerUpdatedAtISO || null,
          version: currentVersion  // 🔥 FIX: Version meesturen voor server-side check
        });

        (async () => {
          try {
            const headers = await getAuthHeaders();
            fetch(API_BASE + '/calendar/save', {
              method: 'POST',
              headers: headers,
              body: payload,
              keepalive: true,
            }).catch(() => {
              const blob = new Blob([payload], { type: 'text/plain;charset=UTF-8' });
              navigator.sendBeacon(API_BASE + '/calendar/save', blob);
            });
          } catch(e) {
            calError('[SAVE] Error getting auth headers:', e);
          }
        })();
      } catch(_) {}
    }
  });
  
  document.addEventListener('turbolinks:before-visit', function() {
    if (dirty && SERVER_OK && !inflight) {
      pushServerNow();
    }
  });
  
  window.addEventListener('pagehide', function(){
    if (dirty && SERVER_OK && !inflight) {
      try {
        const snapshot = (geurkalender || []).slice(0,12).map(sanitizeItem);
        const currentVersion = parseInt(localStorage.getItem(`gk_version_${CUSTOMER_ID}`) || '0');
        const payload = JSON.stringify({
          customer_id: CUSTOMER_ID,
          months: snapshot,
          clientUpdatedAt: lastServerUpdatedAtISO || null,
          version: currentVersion  // 🔥 FIX: Version meesturen voor server-side check
        });

        (async () => {
          try {
            const headers = await getAuthHeaders();
            fetch(API_BASE + '/calendar/save', {
              method: 'POST',
              headers: headers,
              body: payload,
              keepalive: true
            }).catch(() => {});
          } catch(e) {
            calError('[SAVE] Error getting auth headers:', e);
          }
        })();
      } catch(_) {}
    }
  });

  /* ======================== VERSION CHECKING ======================== */
async function ensureFreshCalendarData() {
  if (!IS_SUBSCRIBER) return false;
  
  const now = Date.now();
  const localVersion = parseInt(localStorage.getItem(`gk_version_${CUSTOMER_ID}`) || '0');
  
  // Use cached version if recent (<1 min)
  if (cachedVersion !== null && (now - lastVersionCheck) < VERSION_CACHE_TTL) {
    if (cachedVersion === localVersion) {
      return false; // Already fresh
    }
  }
  
  try {
    // Lightweight version check
    const headers = await getCacheHeaders();
    const versionResp = await fetch(
      `${API_BASE}/calendar/version?customer_id=${CUSTOMER_ID}&cycle=${window.smCustomerCycle || '15'}&_=${now}`,
      { cache: 'no-store', headers: headers }
    );
    
    if (!versionResp.ok) return false;
    
    const versionData = await versionResp.json();
    const serverVersion = versionData.version || 0;
    
    // Update cache
    cachedVersion = serverVersion;
    lastVersionCheck = now;
    
    if (serverVersion > localVersion) {
      calLog(`[VERSION] Refreshing calendar (${localVersion} → ${serverVersion})`);

      // Fetch fresh calendar data
      const headers2 = await getCacheHeaders();
      const dataResp = await fetch(
        `${API_BASE}/calendar?customer_id=${CUSTOMER_ID}&_=${now}`,
        { cache: 'no-store', headers: headers2 }
      );
      
      if (!dataResp.ok) return false;
      
      const calData = await dataResp.json();
      
      // Update global state
      geurkalender = (calData.months || []).slice(0, 12).map(sanitizeItem);
      localStorage.setItem(`gk_version_${CUSTOMER_ID}`, String(serverVersion));
      writeLocal(ACTIVE_KEY, geurkalender);
      markeerKalenderKlaar();
      
      if (Array.isArray(calData.labels)) {
        window.gkServerLabels = calData.labels;
        writeCachedLabels(calData.labels);
        labelsPreloaded = true;
      }
      
      if (calData.updatedAt) {
        lastServerUpdatedAtISO = calData.updatedAt;
        lastServerUpdatedAtMS = tsNum(calData.updatedAt);
        writeUpdated(lastServerUpdatedAtISO, lastServerUpdatedAtMS);
      }
      
      // Trigger event
      try {
        document.dispatchEvent(new CustomEvent('gk:version-updated', { 
          detail: { version: serverVersion, months: geurkalender } 
        }));
      } catch(_) {}
      
      return true; // Was updated
    }
    
    return false; // Already fresh
  } catch (e) {
    calError('[VERSION] Check failed:', e);
    return false;
  }
}


  /* ======================== 🔥 INIT MET LABEL PRELOADING ======================== */
  // geurkalender.js - UPDATE initCalendar (rond regel 1000)

// geurkalender.js - REPLACE initCalendar

(async function initCalendar() {
    let forceRefresh = false;

    // 0️⃣ HARD CHECK (NIEUW): Is data verlopen op basis van datum?
    if (IS_SUBSCRIBER && isLocalDataExpired()) {
        calLog('[INIT] ⚠️ Data expired by date check - Clearing cache');
        localStorage.removeItem(ACTIVE_KEY);
        localStorage.removeItem(`gk_version_${CUSTOMER_ID}`);
        forceRefresh = true;
    }

    // 1️⃣ Voor subscribers: Check version
    if (IS_SUBSCRIBER && SERVER_OK && !forceRefresh) {
      try {
        const headers = await getCacheHeaders();
        const versionResp = await fetch(
          `${API_BASE}/calendar/version?customer_id=${CUSTOMER_ID}&t=${Date.now()}`,
          { cache: 'no-store', headers: headers }
        );

        if (versionResp.ok) {
          const versionData = await versionResp.json();
          const serverVersion = versionData.version || 0;
          const localVersion = parseInt(localStorage.getItem(`gk_version_${CUSTOMER_ID}`) || '0');

          if (serverVersion > localVersion) {
            calLog('[INIT] Version mismatch - refreshing...');
            forceRefresh = true;
          } else {
             geurkalender = readLocal(ACTIVE_KEY);

             // De versie klopt, maar de lokale cache kan alsnog leeg zijn: andere
             // browser, site-data gewist, of eerste bezoek na inloggen. 'Leeg' is
             // dan een AANNAME, geen feit. Haal in dat geval alsnog de serverstand.
             //
             // Waarom dit ertoe doet: deze tak riep markeerKalenderKlaar() nooit aan,
             // en dat is het enige moment waarop gk:months-changed afgaat. De
             // homepage-hero luistert daarnaar en had zichzelf al met rust gelaten
             // (zijn eigen guard), dus die bleef staan op de server-standaard
             // 'Je geurkalender is nog leeg' terwijl er gewoon geuren in stonden.
             // De mobiele sub-bar had er geen last van: die haalt de kalender zelf op.
             if (!(geurkalender || []).some(Boolean)) {
               calLog('[INIT] Lokale cache leeg ondanks gelijke versie - alsnog ophalen');
               forceRefresh = true;
             } else {
               // Cache is betrouwbaar en gevuld: meld dat de stand definitief is,
               // zodat de hero en de sub-bar hun tik krijgen.
               markeerKalenderKlaar();
             }
          }
        }
      } catch (e) {
        // De versie-controle is niet gelukt: Render koud gestart, time-out, of
        // netwerkhapering. Dit is JUIST het geval na een tijd niets doen.
        // Zonder de meldingen hieronder bleef de homepage-hero op de
        // server-standaard 'Je geurkalender is nog leeg' staan, want dit pad
        // stuurde nooit gk:months-changed.
        geurkalender = readLocal(ACTIVE_KEY);
        if (!(geurkalender || []).some(Boolean)) {
          // Cache leeg en we konden niets verifieren: alsnog proberen op te halen.
          calLog('[INIT] Versie-controle mislukt en cache leeg - alsnog ophalen');
          forceRefresh = true;
        } else {
          markeerKalenderKlaar();
        }
      }
    } else if (!forceRefresh) {
      geurkalender = readLocal(ACTIVE_KEY);
      if (!IS_SUBSCRIBER && LABELS_CACHE_KEY) {
        try { sessionStorage.removeItem(LABELS_CACHE_KEY); } catch(_) {}
      }
      // Ook hier melden zodra er echt iets staat, anders wacht de hero eeuwig.
      // Bij een lege lijst NIET melden: dan weten we niet of dat klopt.
      if ((geurkalender || []).some(Boolean)) markeerKalenderKlaar();
    }

    // 2️⃣ Als refresh nodig is, haal verse data
    if (forceRefresh && SERVER_OK) {
        calLog('[INIT] Fetching fresh data form server...');
        const headers2 = await getCacheHeaders();
        try {
            const dataResp = await fetch(
              `${API_BASE}/calendar?customer_id=${CUSTOMER_ID}&_=${Date.now()}`,
              { cache: 'no-store', headers: headers2 }
            );
            
            if (dataResp.ok) {
              const data = await dataResp.json();
              geurkalender = (data.months || []).slice(0, 12).map(sanitizeItem);
              
              if (data.version) localStorage.setItem(`gk_version_${CUSTOMER_ID}`, String(data.version));
              
              if (data.updatedAt) {
                  lastServerUpdatedAtISO = data.updatedAt;
                  lastServerUpdatedAtMS = tsNum(data.updatedAt);
                  writeUpdated(lastServerUpdatedAtISO, lastServerUpdatedAtMS);
              }
              
              writeLocal(ACTIVE_KEY, geurkalender);
              markeerKalenderKlaar();
              if (data.labels) {
                window.gkServerLabels = data.labels;
                writeCachedLabels(data.labels);
              }
            }
        } catch(e) {}
    }

    // 3️⃣ Render
    renderKalender();
    try { fillGuestFirstShip(); } catch(e){}  // "wanneer komt mijn eerste parfum" hint vullen (niet-abonnees)

    // 4️⃣ Background taken
    if (!IS_SUBSCRIBER) await attemptMergeGuestIntoUser();

    if (SERVER_OK) {
      if (!forceRefresh) refreshFromServer();
      loadGiftBlockStatus();
    }

    if (location.hash === '#geurkalender') {
      // Strip de hash uit de URL (zodat browser back-knop geen rare loop maakt)
      try { history.replaceState(history.state && { ...history.state, gkOpen: false }, '', location.pathname + location.search); } catch(e) {}
      // Open de modal automatisch (bv. vanuit verzendmail of deeplinks)
      try { showModalOnly(); } catch(e) {}
    }
})();
});
